/**
 * Theme JS - Core Interactivity for Custom Shopify Theme
 */

/**
 * Gate legal de personalizacion — UNA sola implementacion para las ocho rutas al carrito.
 *
 * El tema hace POST /cart/add.js desde ocho sitios y solo el boton principal de la ficha
 * envia `properties[...]`. Las otras siete mandan `id` y `quantity` a secas, asi que un
 * producto personalizable entraba al pedido sin foto y sin la autorizacion de uso de imagen
 * que exige la Ley 1581 de 2012 — y eso incluye fotos de menores y de mascotas.
 *
 * Se lleva al cliente a la ficha, que es el unico sitio donde vive el formulario.
 *
 * TRES DECISIONES QUE IMPORTAN:
 *
 * 1. FALLA CERRADO. Si el producto esta marcado como personalizable pero no hay handle al
 *    que redirigir, bloquea y avisa. Antes seguia de largo hasta el POST: la marca estaba
 *    puesta y aun asi el pedido entraba sin autorizacion.
 * 2. LEE EL ANCESTRO, no solo el boton. `updateSelectedVariant()` borra la clase
 *    `quick-add-trigger` del boton al elegir una talla, y el gate anterior colgaba de esa
 *    clase. Los atributos viven tambien en `.product-card-item`, que ningun JS muta.
 * 3. NO DEPENDE DE UNA CLASE CSS. Un control legal que se apaga cuando el propio codigo
 *    reescribe un `className` no es un control.
 *
 * Devuelve true si bloqueo el paso (quien llama debe abortar).
 */
window.atelierGatePersonalizado = function (btn) {
  if (!btn || !btn.closest) return false;

  const marcado = btn.closest('[data-personalizado="true"]');
  if (!marcado) return false;

  const conHandle = btn.closest('[data-handle-perso]');
  const handle = conHandle ? conHandle.getAttribute('data-handle-perso') : '';

  if (handle) {
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = raiz + 'products/' + handle;
    return true;
  }

  // Sin handle no hay a donde llevarlo, pero dejarlo pasar seria meter la foto de un
  // cliente al pedido sin su autorizacion. Se bloquea y se deja rastro.
  console.error('[ATELIER] Producto personalizable sin data-handle-perso: se bloquea el paso al carrito.', btn);
  if (typeof showToast === 'function') {
    showToast('Este regalo se personaliza en su página. Ábrelo para subir tu foto.');
  }
  return true;
};

/**
 * ¿Este producto es personalizable? Decide sobre las etiquetas reales.
 *
 * Las rutas que piden /products/{handle}.js reciben `tags` en la respuesta, asi que no
 * necesitan que el gate viaje en el marcado: preguntan por el dato. Es la comprobacion mas
 * fiable que hay en el navegador, porque no depende de que alguien se acuerde de poner un
 * atributo en una plantilla.
 *
 * Insensible a mayusculas y a espacios sobrantes, igual que el lado Liquid.
 */
window.atelierEsPersonalizado = function (producto) {
  if (!producto || !Array.isArray(producto.tags)) return false;
  return producto.tags.some(function (t) {
    return String(t).toLowerCase().trim() === 'personalizado';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initHeaderSelectors();
  initCartDrawer();
  initCartAjaxHandlers();
  initProductPageBuyButtons();
  initSearchModal();
  initBackToTop();
  initMobileFooterAccordions();
  initProductCards();
  initCollectionFilters();
  initMainProductWishlist();
  initWishlistDrawer();
  initCartCoupon();

  if (window.themeWishlist) {
    window.themeWishlist.updateUI();
  }

  // Track Collection Page Context for Breadcrumbs
  if (window.location.pathname.startsWith('/collections/') && !window.location.pathname.includes('/products/')) {
    const titleEl = document.querySelector('.collection-main-title') || document.querySelector('h1');
    if (titleEl) {
      sessionStorage.setItem('last_collection_url', window.location.pathname + window.location.search);
      sessionStorage.setItem('last_collection_title', titleEl.textContent.trim());
    }
  }

  // FALLBACK: Abre el cart drawer si hubo una recarga/redirección física de Fast Bundle como plan B
  if (sessionStorage.getItem('open_cart_after_reload') === 'true') {
    sessionStorage.removeItem('open_cart_after_reload');
    setTimeout(() => {
      if (window.refreshCartDrawer) {
        window.refreshCartDrawer(true);
      }
    }, 350);
  }
});

/**
 * Initializes the mobile menu drawer and teleportation
 */
function initMobileMenu() {
  const drawer = document.getElementById('MobileNavDrawer');
  const overlay = document.querySelector('.mobile-drawer-overlay');

  if (!drawer) return;

  // Clean up any existing duplicate drawer elements in body
  const existingDrawers = document.querySelectorAll('body > .mobile-navigation-drawer');
  existingDrawers.forEach(d => {
    if (d !== drawer) d.remove();
  });

  const existingOverlays = document.querySelectorAll('body > .mobile-drawer-overlay');
  existingOverlays.forEach(o => {
    if (o !== overlay) o.remove();
  });

  // Teleport drawer and overlay to body to escape the header's CSS transform containing block
  if (overlay && overlay.parentNode !== document.body) {
    document.body.appendChild(overlay);
  }
  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }
}

// Helper to close mobile menu
const closeMobileMenu = () => {
  const drawer = document.getElementById('MobileNavDrawer');
  const overlay = document.querySelector('.mobile-drawer-overlay');
  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    const hamburger = document.querySelector('.mobile-menu-toggle');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }
  if (overlay) overlay.classList.remove('is-active');
  document.body.style.overflow = '';
};

// Global delegated event listeners for mobile navigation drawer, cart drawer, and wishlist drawer
document.addEventListener('click', (e) => {
  // 1. Toggle Open Mobile Nav
  const toggleBtn = e.target.closest('.mobile-menu-toggle');
  if (toggleBtn) {
    e.preventDefault();
    const drawer = document.getElementById('MobileNavDrawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    return;
  }

  // 2. Toggle Close Mobile Nav
  const closeBtn = e.target.closest('.mobile-drawer-close');
  const overlayClick = e.target.matches('.mobile-drawer-overlay');
  if (closeBtn || overlayClick) {
    e.preventDefault();
    closeMobileMenu();
    return;
  }

  // 3. Open Wishlist Drawer
  const wishlistTrigger = e.target.closest('#HeaderWishlistTrigger, #MobileWishlistTrigger, .hamburger-wishlist-trigger');
  if (wishlistTrigger) {
    e.preventDefault();
    const wishlistDrawer = document.getElementById('WishlistDrawer');
    if (wishlistDrawer) {
      closeMobileMenu();
      wishlistDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  // 4. Open Cart Drawer
  const cartTrigger = e.target.closest('.cart-badge-container, .cart-drawer-trigger');
  if (cartTrigger) {
    e.preventDefault();
    const cartDrawer = document.getElementById('CartDrawer');
    const recPanel = document.getElementById('CartDrawerRecs');
    if (cartDrawer) {
      closeMobileMenu();
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (recPanel) recPanel.classList.remove('is-closed');
    }
    return;
  }

  // 5. Submenu Toggle Accordion
  const submenuToggle = e.target.closest('.mobile-submenu-toggle-btn');
  if (submenuToggle) {
    e.preventDefault();
    const parent = submenuToggle.closest('.mobile-drawer-menu-item');
    const list = parent ? parent.querySelector('.mobile-drawer-submenu-list') : null;
    const plusIcon = submenuToggle.querySelector('.toggle-icon-plus');

    if (list) {
      const isOpen = list.classList.contains('is-open');
      if (isOpen) {
        list.classList.remove('is-open');
        if (plusIcon) plusIcon.textContent = '+';
      } else {
        list.classList.add('is-open');
        if (plusIcon) plusIcon.textContent = '−';
      }
      submenuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
    return;
  }

  // 6. Grandchild Submenu Toggle Accordion
  const grandchildToggle = e.target.closest('.mobile-grandchild-toggle-btn');
  if (grandchildToggle) {
    e.preventDefault();
    const parent = grandchildToggle.closest('.mobile-drawer-submenu-item');
    const list = parent ? parent.querySelector('.mobile-drawer-grandchild-list') : null;
    const chevron = grandchildToggle.querySelector('.toggle-chevron');

    if (list) {
      const isOpen = list.classList.contains('is-open');
      if (isOpen) {
        list.classList.remove('is-open');
        if (chevron) chevron.classList.remove('is-open');
      } else {
        list.classList.add('is-open');
        if (chevron) chevron.classList.add('is-open');
      }
      grandchildToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
    return;
  }
});

// Close drawer on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMobileMenu();
  }
});

// Shopify Theme Editor section load listener to re-teleport header drawer elements
document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId === 'header') {
    initMobileMenu();
  }
});

/**
 * Initializes the Language and Currency selector interactions
 */
function initHeaderSelectors() {
  const dropdownTriggers = document.querySelectorAll('.header-dropdown-trigger');

  dropdownTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const name = trigger.textContent.trim().split(' ')[0];
      // For now, showcase a premium native browser feedback or custom modal.
      // In Shopify production, these are connected to currency/language forms.
      console.log(`Dropdown triggered for: ${name}`);
    });
  });
}

/**
 * Initializes the interactive Cart Drawer (Double-Panel layout)
 */
function initCartDrawer() {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartClose = document.querySelector('.cart-drawer-close');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const continueShopping = document.querySelector('.continue-shopping-link');

  // Recommendations slide-out trigger
  const recClose = document.querySelector('.recommendations-close');
  const recPanel = document.getElementById('CartDrawerRecs');

  if (!cartDrawer) return;




  // Fetch Dynamic Product Recommendations API when product_recommendations option is enabled
  const updateProductRecommendations = async () => {
    const recType = cartDrawer.dataset.recommendationsType;
    const lastProductId = cartDrawer.dataset.lastProductId;
    if ((recType === 'product_recommendations' || recType === 'last_added_collection') && lastProductId) {
      const hideSoldOut = cartDrawer.dataset.hideSoldOut === 'true';
      const btnStyle = cartDrawer.dataset.upsellBtnStyle || 'link';
      const btnClass = btnStyle === 'button' ? 'rec-add-to-cart-btn rec-add-to-cart-btn--button' : 'rec-add-to-cart-btn';
      const mobileBtnClass = btnStyle === 'button' ? 'mobile-rec-btn mobile-rec-btn--button' : 'mobile-rec-btn';
      
      try {
        const response = await fetch(`${window.Shopify ? window.Shopify.routes.root : '/'}recommendations/products.json?product_id=${lastProductId}&limit=8`);
        if (!response.ok) return;
        const data = await response.json();
        if (!data || !data.products || data.products.length === 0) return;

        let products = data.products;
        if (hideSoldOut) {
          products = products.filter(p => p.available);
        }
        products = products.slice(0, 6);
        if (products.length === 0) return;

        // Render Desktop Recs
        const recBody = document.querySelector('#CartDrawerRecs .recommendations-body');
        if (recBody) {
          recBody.innerHTML = products.map(p => {
            const firstVariant = p.variants ? p.variants.find(v => v.available) || p.variants[0] : null;
            const variantId = firstVariant ? firstVariant.id : '';
            const priceMoney = window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(p.price) : `$${(p.price / 100).toFixed(2)}`;
            const comparePriceMoney = p.compare_at_price > p.price ? (window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(p.compare_at_price) : `$${(p.compare_at_price / 100).toFixed(2)}`) : '';
            const featuredImg = p.featured_image || (p.images && p.images[0]) || '';

            return `
              <div class="rec-product-card">
                <a href="${p.url}" class="rec-image-link">
                  <div class="rec-image-container">
                    <img src="${featuredImg}" alt="${p.title}" class="rec-image">
                  </div>
                </a>
                <h4 class="rec-product-title"><a href="${p.url}">${p.title}</a></h4>
                <p class="rec-product-price">
                  <span class="price-sale">${priceMoney}</span>
                  ${comparePriceMoney ? `<span class="price-compare">${comparePriceMoney}</span>` : ''}
                </p>
                <button type="button" 
                        class="${btnClass} rec-card-add-btn-ajax" 
                        data-variant-id="${variantId}" 
                        aria-label="${p.available ? 'Añadir al carrito ' + p.title : 'Agotado'}"
                        ${!p.available ? 'disabled' : ''}>
                  ${p.available ? 'Añadir al carrito' : 'Agotado'}
                </button>
              </div>
            `;
          }).join('');
        }

        // Render Mobile Recs
        const mobileList = document.querySelector('.cart-drawer-mobile-upsells .mobile-upsells-list');
        if (mobileList) {
          mobileList.innerHTML = products.map(p => {
            const firstVariant = p.variants ? p.variants.find(v => v.available) || p.variants[0] : null;
            const variantId = firstVariant ? firstVariant.id : '';
            const priceMoney = window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(p.price) : `$${(p.price / 100).toFixed(2)}`;
            const comparePriceMoney = p.compare_at_price > p.price ? (window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(p.compare_at_price) : `$${(p.compare_at_price / 100).toFixed(2)}`) : '';
            const featuredImg = p.featured_image || (p.images && p.images[0]) || '';
            const truncatedTitle = p.title.length > 30 ? p.title.substring(0, 30) + '...' : p.title;

            return `
              <div class="mobile-rec-card">
                <div class="mobile-rec-img-box">
                  <img src="${featuredImg}" alt="${p.title}" class="mobile-rec-img">
                </div>
                <div class="mobile-rec-details">
                  <h4 class="mobile-rec-title"><a href="${p.url}">${truncatedTitle}</a></h4>
                  <p class="mobile-rec-price">
                    <span class="price-sale">${priceMoney}</span>
                    ${comparePriceMoney ? `<span class="price-compare">${comparePriceMoney}</span>` : ''}
                  </p>
                  <div class="mobile-rec-action" style="margin-top: 0.3rem;">
                    <button type="button" 
                            class="${mobileBtnClass} rec-card-add-btn-ajax" 
                            data-variant-id="${variantId}" 
                            aria-label="${p.available ? '+ Añadir ' + p.title : 'Agotado'}"
                            ${!p.available ? 'disabled' : ''}>
                      ${p.available ? '+ Añadir' : 'Agotado'}
                    </button>
                  </div>
                </div>
              </div>
            `;
          }).join('');
        }
      } catch (err) {
        console.warn('Error fetching Shopify recommendations API:', err);
      }
    }
  };




  // Open Cart Drawer
  const cartTriggers = document.querySelectorAll('.cart-badge-container, .cart-drawer-trigger');
  cartTriggers.forEach(trigger => {
    if (trigger.dataset.drawerInitialized) return;
    trigger.dataset.drawerInitialized = 'true';
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Lock background scrolling
      // Ensure the recommendations panel is reset to visible when re-opening
      if (recPanel) recPanel.classList.remove('is-closed');
    });
  });

  // Close Cart Drawer
  const closeDrawer = () => {
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (cartClose && !cartClose.dataset.initialized) {
    cartClose.dataset.initialized = 'true';
    cartClose.addEventListener('click', closeDrawer);
  }
  if (cartOverlay && !cartOverlay.dataset.initialized) {
    cartOverlay.dataset.initialized = 'true';
    cartOverlay.addEventListener('click', closeDrawer);
  }
  if (continueShopping && !continueShopping.dataset.initialized) {
    continueShopping.dataset.initialized = 'true';
    continueShopping.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  // Close recommendations panel independently
  if (recClose && recPanel && !recClose.dataset.initialized) {
    recClose.dataset.initialized = 'true';
    recClose.addEventListener('click', (e) => {
      e.preventDefault();
      recPanel.classList.add('is-closed');
    });
  }

  // Utility tabs toggle (Note, Coupon, Gift Wrap)
  const tabButtons = cartDrawer.querySelectorAll('.cart-drawer-tab-btn');
  const addonPanels = cartDrawer.querySelectorAll('.cart-drawer-addon-panel');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const tabId = this.getAttribute('data-tab');
      const panel = cartDrawer.querySelector('#AddonPanel-' + tabId);
      if (!panel) return;

      const isAlreadyActive = this.classList.contains('is-active');

      tabButtons.forEach(b => b.classList.remove('is-active'));
      addonPanels.forEach(p => p.classList.remove('is-active'));

      if (!isAlreadyActive) {
        this.classList.add('is-active');
        panel.classList.add('is-active');
      }
    });
  });
}

/**
 * Initializes the premium Centered Search Modal
 */
/**
 * Initializes the premium Centered Search Modal or Search Drawer based on settings and device
 */
function initSearchModal() {
  const predictiveSearchCache = {};
  const triggers = document.querySelectorAll('.search-modal-trigger');
  const modal = document.getElementById('SearchModal');
  const modalOverlay = document.querySelector('.search-modal-overlay');
  const modalCloseBtn = document.querySelector('.search-modal-close');
  const modalInput = document.querySelector('.search-modal-input');

  const drawer = document.getElementById('SearchDrawer');
  const drawerOverlay = document.querySelector('.search-drawer-overlay');
  const drawerCloseBtn = document.querySelector('.search-drawer-close');
  const drawerInput = document.querySelector('.search-drawer-input');

  if (!drawer) return;

  // Teleport overlay y drawer al body para escapar del CSS transform del header
  if (modalOverlay) document.body.appendChild(modalOverlay);
  // El modal va DENTRO del overlay — así el overlay fixed es el scroll container
  if (modal && modalOverlay) modalOverlay.appendChild(modal);
  if (drawerOverlay) document.body.appendChild(drawerOverlay);
  document.body.appendChild(drawer);

  const desktopSearchType = drawer.getAttribute('data-desktop-search-type') || 'popup';
  const isMobile = () => window.innerWidth <= 1024;

  // Search History Helper Functions
  const getSearchHistory = () => {
    try {
      return JSON.parse(localStorage.getItem('theme_search_history') || '[]');
    } catch (e) {
      return [];
    }
  };

  const updateRecentSearchesUI = () => {
    const history = getSearchHistory();
    const rootUrl = window.Shopify?.routes?.root || '/';
    const rootClean = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

    const html = history.length > 0 ? `
      <div class="search-recent-history-section" style="text-align: left;">
        <h3 class="search-modal-section-title search-drawer-section-title">Búsquedas recientes</h3>
        <div class="search-modal-keywords-list search-drawer-keywords-list" style="display: flex; flex-wrap: wrap; gap: 0.6rem; margin-top: 0.5rem; justify-content: flex-start;">
          ${history.map(term => `<a href="${rootClean}search?q=${encodeURIComponent(term)}&type=product" class="search-keyword-pill search-suggestion-pill">${escapeHtml(term)}</a>`).join('')}
        </div>
      </div>
    ` : '';

    if (modal) {
      const modalDefault = modal.querySelector('.search-modal-default-content');
      if (modalDefault) {
        let historyContainer = modalDefault.querySelector('.search-recent-history-container');
        if (!historyContainer) {
          historyContainer = document.createElement('div');
          historyContainer.className = 'search-recent-history-container';
          modalDefault.insertBefore(historyContainer, modalDefault.firstChild);
        }
        historyContainer.innerHTML = html;
      }
    }

    if (drawer) {
      const drawerDefault = drawer.querySelector('.search-drawer-default-content');
      if (drawerDefault) {
        let historyContainer = drawerDefault.querySelector('.search-recent-history-container');
        if (!historyContainer) {
          historyContainer = document.createElement('div');
          historyContainer.className = 'search-recent-history-container';
          drawerDefault.insertBefore(historyContainer, drawerDefault.firstChild);
        }
        historyContainer.innerHTML = html;
      }
    }
  };

  // Open handler
  const openSearch = (e) => {
    if (e) e.preventDefault();
    closeSearch(); // Close any currently open search container first
    updateRecentSearchesUI(); // Refresh history list

    if (isMobile() || desktopSearchType === 'drawer') {
      // Open Search Drawer (panel lateral) — bloquea body scroll
      drawer.classList.add('is-open');
      if (drawerOverlay) drawerOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (drawerInput) drawerInput.focus();
      }, 150);
    } else {
      // Open Search Modal Popup — el overlay fixed cubre la pantalla y hace scroll
      if (modal) {
        modal.classList.add('is-open');
        if (modalOverlay) {
          modalOverlay.classList.add('is-active');
          modalOverlay.scrollTop = 0; // Siempre empieza desde arriba
        }
        document.body.style.overflow = 'hidden'; // Bloquea el body detrás
        setTimeout(() => {
          if (modalInput) modalInput.focus();
        }, 150);
      }
    }
  };

  // Close handler
  const closeSearch = () => {
    if (modal) modal.classList.remove('is-open');
    if (modalOverlay) modalOverlay.classList.remove('is-active');
    if (drawer) drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  // Bind trigger click events
  triggers.forEach(trigger => {
    trigger.addEventListener('click', openSearch);
  });

  // Bind hamburger menu search trigger, if any exists in mobile nav
  const hamburguerSearchTrigger = document.querySelector('.hamburger-search-trigger');
  if (hamburguerSearchTrigger) {
    hamburguerSearchTrigger.addEventListener('click', openSearch);
  }

  // Close events
  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeSearch);
  if (modalOverlay) {
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) {
        closeSearch();
      }
    });
  }
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeSearch);
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) {
        closeSearch();
      }
    });
  }
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', (e) => {
      if (e.target === drawerOverlay) {
        closeSearch();
      }
    });
  }

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  // Predictive search logic for Drawer Input
  let debounceTimeout;
  if (drawerInput) {
    const resultsContainer = document.getElementById('SearchDrawerResults');
    const defaultContent = drawer.querySelector('.search-drawer-default-content');
    const loadingSpinner = drawer.querySelector('.search-drawer-loading');

    const renderDrawerResults = (data, query, rootClean) => {
      const products = data.resources?.results?.products || [];
      const queries = data.resources?.results?.queries || [];
      const collections = data.resources?.results?.collections || [];
      const articles = data.resources?.results?.articles || [];

      if (products.length === 0 && queries.length === 0 && collections.length === 0 && articles.length === 0) {
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        resultsContainer.innerHTML = `
          <div class="search-drawer-no-results">
            <p>No se encontraron resultados para "<strong>${escapeHtml(query)}</strong>"</p>
          </div>`;
      } else {
        // Build dynamic query suggestions HTML
        let suggestionsHtml = '';
        if (queries.length > 0) {
          suggestionsHtml = `
            <div class="search-suggestions-container" style="text-align: left;">
              <h4 class="search-suggestions-title search-drawer-section-title">Sugerencias de búsqueda</h4>
              <div class="search-suggestions-list" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 1rem;">
                ${queries.map(q => `<a href="${q.url}" class="search-suggestion-pill search-keyword-pill">${highlightQuery(q.text, query)}</a>`).join('')}
              </div>
            </div>`;
        }

        // Build collections suggestions HTML
        let collectionsHtml = '';
        if (collections.length > 0) {
          collectionsHtml = `
            <div class="search-collections-container" style="text-align: left; margin-bottom: 1.5rem;">
              <h4 class="search-collections-title search-drawer-section-title">Encontrado en Colecciones</h4>
              <div class="search-collections-list" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.5rem;">
                ${collections.map(c => `
                  <a href="${c.url}" class="search-collection-pill search-keyword-pill" style="display: inline-flex; align-items: center; gap: 0.25rem;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581a1.125 1.125 0 0 0 1.59 0l4.318-4.317a1.125 1.125 0 0 0 0-1.59L9.568 3Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 7.5h.008v.008H6V7.5Z" />
                    </svg>
                    ${escapeHtml(c.title)}
                  </a>
                `).join('')}
              </div>
            </div>`;
        }

        // Build articles suggestions HTML
        let articlesHtml = '';
        if (articles.length > 0) {
          articlesHtml = `
            <div class="search-articles-container" style="text-align: left; margin-bottom: 1.5rem;">
              <h4 class="search-articles-title search-drawer-section-title">Artículos de blog</h4>
              <div class="search-articles-list" style="display: flex; flex-direction: column; gap: 0.5rem; margin-top: 0.5rem;">
                ${articles.map(art => {
                  const artImage = art.image || art.featured_image?.url || '';
                  const imageHtml = artImage ? `<img src="${artImage}" alt="${escapeHtml(art.title)}" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; flex-shrink: 0;" loading="lazy">` : `
                    <div style="width: 40px; height: 40px; background-color: #f1f5f9; border-radius: 4px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16" style="color: #94a3b8;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h10.5m-10.5 3h10.5m-13.5-9h16.5V19.5a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 19.5V5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25V12" />
                      </svg>
                    </div>
                  `;
                  return `
                    <a href="${art.url}" class="search-article-item" style="display: flex; align-items: center; gap: 0.75rem; text-decoration: none; color: inherit; padding: 0.35rem 0.5rem; border-radius: 6px; transition: background-color var(--transition-fast);">
                      ${imageHtml}
                      <div style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        <h5 class="search-article-title" style="margin: 0; font-size: 0.9rem; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(art.title)}</h5>
                        <span style="font-size: 0.75rem; color: #64748b;">Artículo</span>
                      </div>
                    </a>
                  `;
                }).join('')}
              </div>
            </div>`;
        }

        const cardPromises = products.map(product => {
          return fetch(`${rootClean}products/${product.handle}?view=card`)
            .then(res => {
              if (!res.ok) throw new Error('Card fetch fail');
              return res.text();
            })
            .catch(() => {
              const price = product.price;
              const comparePrice = product.compare_at_price;
              const compareHtml = comparePrice ? `<span class="product-card-compare-price">${comparePrice}</span>` : '';
              return `
                <div class="product-card-item">
                  <div class="product-card-image-wrapper">
                    <a href="${product.url}" class="product-card-image-link">
                      <img src="${product.featured_image?.url || product.image || '//cdn.shopify.com/s/images/themes/product-1.png'}" alt="${escapeHtml(product.title)}" class="product-card-img" loading="lazy">
                    </a>
                  </div>
                  <div class="product-card-info align-left">
                    <h4 class="product-card-title">
                      <a href="${product.url}">${escapeHtml(product.title)}</a>
                    </h4>
                    <div class="product-card-pricing">
                      <span class="product-card-price">${price}</span>
                      ${compareHtml}
                    </div>
                  </div>
                </div>`;
            });
        });

        Promise.all(cardPromises).then(htmlArray => {
          if (loadingSpinner) loadingSpinner.style.display = 'none';
          const productsHtml = htmlArray.length > 0 ? `
            <div class="search-products-section" style="text-align: left;">
              <h4 class="search-products-title search-drawer-section-title" style="margin-bottom: 0.75rem;">Productos</h4>
              <div class="search-drawer-results-list">${htmlArray.join('')}</div>
            </div>
          ` : '';
          resultsContainer.innerHTML = `${suggestionsHtml}${collectionsHtml}${articlesHtml}${productsHtml}`;
        }).catch(err => {
          console.error('Error rendering product cards:', err);
          if (loadingSpinner) loadingSpinner.style.display = 'none';
        });
      }
    };

    drawerInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      clearTimeout(debounceTimeout);

      if (query.length < 2) {
        if (resultsContainer) {
          resultsContainer.innerHTML = '';
          resultsContainer.style.display = 'none';
        }
        if (defaultContent) defaultContent.style.display = 'flex';
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        return;
      }

      if (loadingSpinner) loadingSpinner.style.display = 'flex';
      if (defaultContent) defaultContent.style.display = 'none';
      if (resultsContainer) resultsContainer.style.display = 'block';

      const rootUrl = window.Shopify?.routes?.root || '/';
      const rootClean = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

      if (predictiveSearchCache[query]) {
        renderDrawerResults(predictiveSearchCache[query], query, rootClean);
        return;
      }

      debounceTimeout = setTimeout(() => {
        fetch(`${rootClean}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article,query&resources[limit]=5&resources[limit_scope]=each`)
          .then(res => res.json())
          .then(data => {
            predictiveSearchCache[query] = data;
            renderDrawerResults(data, query, rootClean);
          })
          .catch(err => {
            console.error('Error fetching predictive search:', err);
            if (loadingSpinner) loadingSpinner.style.display = 'none';
          });
      }, 200);
    });
  }

  // Predictive search logic for Modal Input
  let modalDebounceTimeout;
  if (modalInput && modal) {
    const resultsContainer = document.getElementById('SearchModalResults');
    const defaultContent = modal.querySelector('.search-modal-default-content');
    const loadingSpinner = modal.querySelector('.search-modal-loading');

    const renderModalResults = (data, query, rootClean) => {
      const products = data.resources?.results?.products || [];
      const queries = data.resources?.results?.queries || [];
      const collections = data.resources?.results?.collections || [];
      const articles = data.resources?.results?.articles || [];

      if (products.length === 0 && queries.length === 0 && collections.length === 0 && articles.length === 0) {
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        resultsContainer.innerHTML = `
          <div class="search-modal-no-results">
            <p>No se encontraron resultados para "<strong>${escapeHtml(query)}</strong>"</p>
          </div>`;
        return;
      }

      // Build dynamic query suggestions HTML
      let suggestionsHtml = '';
      if (queries.length > 0) {
        suggestionsHtml = `
          <div class="search-suggestions-container" style="text-align: left;">
            <h4 class="search-suggestions-title search-modal-section-title">Sugerencias de búsqueda</h4>
            <div class="search-suggestions-list" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 1.5rem;">
              ${queries.map(q => `<a href="${q.url}" class="search-suggestion-pill search-keyword-pill">${highlightQuery(q.text, query)}</a>`).join('')}
            </div>
          </div>`;
      }

      // Build collections suggestions HTML
      let collectionsHtml = '';
      if (collections.length > 0) {
        collectionsHtml = `
          <div class="search-collections-container" style="text-align: left; margin-bottom: 1.5rem;">
            <h4 class="search-collections-title search-modal-section-title">Encontrado en Colecciones</h4>
            <div class="search-collections-list" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.5rem;">
              ${collections.map(c => `
                <a href="${c.url}" class="search-collection-pill search-keyword-pill" style="display: inline-flex; align-items: center; gap: 0.25rem;">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581a1.125 1.125 0 0 0 1.59 0l4.318-4.317a1.125 1.125 0 0 0 0-1.59L9.568 3Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 7.5h.008v.008H6V7.5Z" />
                  </svg>
                  ${escapeHtml(c.title)}
                </a>
              `).join('')}
            </div>
          </div>`;
      }

      // Build articles suggestions HTML
      let articlesHtml = '';
      if (articles.length > 0) {
        articlesHtml = `
          <div class="search-articles-container" style="text-align: left; margin-bottom: 1.5rem;">
            <h4 class="search-articles-title search-modal-section-title">Artículos de blog</h4>
            <div class="search-articles-list" style="display: flex; flex-direction: column; gap: 0.5rem; margin-top: 0.5rem;">
              ${articles.map(art => {
                const artImage = art.image || art.featured_image?.url || '';
                const imageHtml = artImage ? `<img src="${artImage}" alt="${escapeHtml(art.title)}" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; flex-shrink: 0;" loading="lazy">` : `
                  <div style="width: 40px; height: 40px; background-color: #f1f5f9; border-radius: 4px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16" style="color: #94a3b8;">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h10.5m-10.5 3h10.5m-13.5-9h16.5V19.5a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 19.5V5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25V12" />
                    </svg>
                  </div>
                `;
                return `
                  <a href="${art.url}" class="search-article-item" style="display: flex; align-items: center; gap: 0.75rem; text-decoration: none; color: inherit; padding: 0.35rem 0.5rem; border-radius: 6px; transition: background-color var(--transition-fast);">
                    ${imageHtml}
                    <div style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      <h5 class="search-article-title" style="margin: 0; font-size: 0.9rem; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(art.title)}</h5>
                      <span style="font-size: 0.75rem; color: #64748b;">Artículo</span>
                    </div>
                  </a>
                `;
              }).join('')}
            </div>
          </div>`;
      }

      // Products loading skeleton setup (rendered immediately)
      let productsHtml = '';
      const aspectStyle = modal.getAttribute('data-card-aspect-ratio') || '3 / 4';
      if (products.length > 0) {
        productsHtml = `
          <div class="search-products-section" style="text-align: left;">
            <h4 class="search-products-title search-modal-section-title" style="margin-bottom: 0.75rem;">Productos</h4>
            <div class="search-modal-results-grid">
              ${products.map(() => `<div class="search-skeleton-card" style="width: 100%; aspect-ratio: ${aspectStyle}; height: 260px;"></div>`).join('')}
            </div>
          </div>`;
      }

      // Render suggestions, collections, articles, and product skeleton IMMEDIATELY
      resultsContainer.innerHTML = `${suggestionsHtml}${collectionsHtml}${articlesHtml}${productsHtml}`;
      if (loadingSpinner) loadingSpinner.style.display = 'none';

      // Load products asynchronously in background
      if (products.length > 0) {
        const cardPromises = products.map(product => {
          return fetch(`${rootClean}products/${product.handle}?view=card`)
            .then(res => {
              if (!res.ok) throw new Error('Card fetch fail');
              return res.text();
            })
            .catch(() => {
              const price = product.price;
              const comparePrice = product.compare_at_price;
              const compareHtml = comparePrice ? `<span class="product-card-compare-price">${comparePrice}</span>` : '';
              return `
                <div class="product-card-item" style="--card-aspect-ratio: ${aspectStyle};">
                  <div class="product-card-image-wrapper">
                    <a href="${product.url}" class="product-card-image-link">
                      <img src="${product.featured_image?.url || product.image || '//cdn.shopify.com/s/images/themes/product-1.png'}" alt="${escapeHtml(product.title)}" class="product-card-img" loading="lazy">
                    </a>
                  </div>
                  <div class="product-card-info align-left">
                    <h4 class="product-card-title">
                      <a href="${product.url}">${escapeHtml(product.title)}</a>
                    </h4>
                    <div class="product-card-pricing">
                      <span class="product-card-price">${price}</span>
                      ${compareHtml}
                    </div>
                  </div>
                </div>`;
            });
        });

        Promise.all(cardPromises).then(htmlArray => {
          const sectionContainer = resultsContainer.querySelector('.search-products-section');
          if (sectionContainer) {
            sectionContainer.innerHTML = `
              <h4 class="search-products-title search-modal-section-title" style="margin-bottom: 0.75rem;">Productos</h4>
              <div class="search-modal-results-grid">${htmlArray.join('')}</div>
            `;

            // Re-initialize hover states, swatch clicks, and AJAX cart buttons for the new cards!
            if (typeof initProductCards === 'function') initProductCards();
            if (typeof initCartAjaxHandlers === 'function') initCartAjaxHandlers();
          }
        }).catch(err => {
          console.error('Error rendering product cards:', err);
        });
      }
    };

    modalInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      clearTimeout(modalDebounceTimeout);

      if (query.length < 2) {
        if (resultsContainer) {
          resultsContainer.innerHTML = '';
          resultsContainer.style.display = 'none';
        }
        if (defaultContent) defaultContent.style.display = 'block';
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        return;
      }

      if (loadingSpinner) loadingSpinner.style.display = 'flex';
      if (defaultContent) defaultContent.style.display = 'none';
      if (resultsContainer) resultsContainer.style.display = 'block';

      const rootUrl = window.Shopify?.routes?.root || '/';
      const rootClean = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

      if (predictiveSearchCache[query]) {
        renderModalResults(predictiveSearchCache[query], query, rootClean);
        return;
      }

      modalDebounceTimeout = setTimeout(() => {
        fetch(`${rootClean}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article,query&resources[limit]=8&resources[limit_scope]=each`)
          .then(res => res.json())
          .then(data => {
            predictiveSearchCache[query] = data;
            renderModalResults(data, query, rootClean);
          })
          .catch(err => {
            console.error('Error fetching predictive search:', err);
            if (loadingSpinner) loadingSpinner.style.display = 'none';
          });
      }, 200);
    });
  }

  function highlightQuery(text, query) {
    if (!query) return escapeHtml(text);
    const queryClean = query.toLowerCase();
    const index = text.toLowerCase().indexOf(queryClean);
    if (index !== -1) {
      const before = text.substring(0, index);
      const match = text.substring(index, index + query.length);
      const after = text.substring(index + query.length);
      return `${escapeHtml(before)}<strong style="color: var(--color-search-highlight, #ef4444); font-weight: 600;">${escapeHtml(match)}</strong>${escapeHtml(after)}`;
    }
    return escapeHtml(text);
  }

  // Web Speech API / Mic support helper
  function initVoiceSearch(micBtn, inputEl) {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      let recognition = null;
      let isRecording = false;

      const startSpeechRecognition = () => {
        try {
          recognition = new SpeechRecognition();
          recognition.continuous = false;
          
          // Detect theme language or default to Spanish (es-ES)
          const docLang = document.documentElement.lang || 'es';
          if (docLang.startsWith('es')) {
            recognition.lang = 'es-ES';
          } else if (docLang.startsWith('en')) {
            recognition.lang = 'en-US';
          } else {
            recognition.lang = docLang;
          }

          recognition.interimResults = false;
          recognition.maxAlternatives = 1;

          recognition.onstart = () => {
            isRecording = true;
            micBtn.classList.add('is-recording');
            inputEl.placeholder = 'Escuchando...';
            inputEl.value = '';
          };

          recognition.onend = () => {
            isRecording = false;
            micBtn.classList.remove('is-recording');
            inputEl.placeholder = inputEl.getAttribute('data-placeholder') || 'Escribe para buscar...';
          };

          recognition.onerror = (event) => {
            console.error('Speech recognition error event:', event.error);
            isRecording = false;
            micBtn.classList.remove('is-recording');
            inputEl.placeholder = inputEl.getAttribute('data-placeholder') || 'Escribe para buscar...';
          };

          recognition.onresult = (event) => {
            const speechToText = event.results[0][0].transcript;
            inputEl.value = speechToText;
            inputEl.dispatchEvent(new Event('input'));
          };

          recognition.start();
        } catch (err) {
          console.error('Failed to start SpeechRecognition:', err);
        }
      };

      micBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (isRecording && recognition) {
          recognition.stop();
        } else {
          startSpeechRecognition();
        }
      });
    } else {
      micBtn.style.display = 'none';
    }
  }

  // Bind Voice Search for Desktop Popup
  const modalMicBtn = document.querySelector('.search-modal-mic');
  if (modalMicBtn && modalInput) {
    initVoiceSearch(modalMicBtn, modalInput);
  }

  // Bind Voice Search for Mobile / Desktop Drawer
  const drawerMicBtn = document.querySelector('.search-drawer-mic');
  if (drawerMicBtn && drawerInput) {
    initVoiceSearch(drawerMicBtn, drawerInput);
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
}

/**
 * Initializes the premium floating Back to Top button
 */
function initBackToTop() {
  const backToTopBtn = document.getElementById('BackToTopBtn');
  if (!backToTopBtn) return;

  // Show button when scrolling down beyond 400px.
  // passive: el handler nunca cancela el scroll, así el navegador no espera al JS.
  // El guard evita tocar classList (y disparar style recalc) en cada evento:
  // solo escribe cuando el estado realmente cambia.
  let backToTopVisible = false;
  window.addEventListener('scroll', () => {
    const shouldShow = window.pageYOffset > 400;
    if (shouldShow === backToTopVisible) return;
    backToTopVisible = shouldShow;
    backToTopBtn.classList.toggle('is-visible', shouldShow);
  }, { passive: true });

  // Smooth scroll to top when clicked
  backToTopBtn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

/**
 * Initializes the mobile collapsible footer accordions with scrollHeight transitions
 */
function initMobileFooterAccordions() {
  const headers = document.querySelectorAll('.footer-col-header');
  const breakpoint = 1024; // Matching the CSS media query max-width: 1024px

  const setInitialState = () => {
    const isMobile = window.innerWidth <= breakpoint;
    headers.forEach(header => {
      const content = header.nextElementSibling;
      if (!content) return;

      if (isMobile) {
        // On mobile, start collapsed unless the header has class 'is-open' or data-default-open is true
        const isOpen = header.classList.contains('is-open') || header.getAttribute('data-default-open') === 'true';
        if (isOpen) {
          header.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
          content.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          header.classList.remove('is-open');
          header.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-open');
          content.style.maxHeight = '0px';
        }
      } else {
        // On desktop, clean up all inline styles so CSS takes over
        header.classList.remove('is-open');
        header.removeAttribute('aria-expanded');
        content.classList.remove('is-open');
        content.style.maxHeight = '';
      }
    });
  };

  // Run initially
  setTimeout(setInitialState, 150);

  // Handle click events
  headers.forEach(header => {
    if (header.dataset.accordionInitialized) return;
    header.dataset.accordionInitialized = 'true';

    header.addEventListener('click', (e) => {
      if (window.innerWidth > breakpoint) return;
      e.preventDefault();

      const content = header.nextElementSibling;
      if (!content) return;

      const isOpen = header.classList.contains('is-open');

      if (isOpen) {
        header.classList.remove('is-open');
        header.setAttribute('aria-expanded', 'false');
        content.classList.remove('is-open');
        content.style.maxHeight = '0px';
      } else {
        header.classList.add('is-open');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Re-evaluate on window resize.
  // Debounced: setInitialState lee scrollHeight de cada acordeón (reflow forzado)
  // y en móvil la barra de URL dispara resize durante el scroll — sin debounce
  // eso significaba una ráfaga de reflows justo mientras el usuario navega.
  let footerResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(footerResizeTimer);
    footerResizeTimer = setTimeout(setInitialState, 150);
  });
}

/**
 * Initializes interactive behaviors for premium product cards
 */
function initProductCards() {
  // 0. Observa los marquees de las tarjetas que acaben de entrar al DOM.
  //    Se llama desde acá porque initProductCards ya corre después de cada
  //    render por AJAX (filtros de colección, cargar más, resultados de búsqueda).
  initMarqueePausing();

  // 1. Wishlist click feedback
  const wishlistBtns = document.querySelectorAll('.product-card-action-btn.wishlist-btn, .list-action-btn.wishlist-btn');
  wishlistBtns.forEach(btn => {
    if (btn.dataset.wishlistInitialized) return;
    btn.dataset.wishlistInitialized = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.product-card-item');
      if (!card) return;

      const productData = {
        handle: card.dataset.productHandle,
        id: card.dataset.productId,
        title: card.dataset.productTitle,
        price: card.dataset.productPrice,
        compare_price: card.dataset.productComparePrice || null,
        image: card.dataset.productImage,
        url: card.dataset.productUrl,
        variant_id: card.dataset.variantId,
        // La marca viaja con el favorito. Sin esto el cajon pierde el rastro de que el
        // producto lleva foto, y su boton «Anadir al carrito» esquiva el gate legal.
        personalizado: card.getAttribute('data-personalizado') === 'true'
      };

      if (window.themeWishlist) {
        window.themeWishlist.toggle(productData);
      }
    });
  });

  // 2. Compare click feedback (Deactivated but left safe)
  const compareBtns = document.querySelectorAll('.product-card-action-btn.compare-btn');
  compareBtns.forEach(btn => {
    if (btn.dataset.compareInitialized) return;
    btn.dataset.compareInitialized = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // 3. Color Swatch Click Handler
  const swatchBtns = document.querySelectorAll('.product-card-item .swatch-btn');
  swatchBtns.forEach(btn => {
    if (btn.dataset.swatchInitialized) return;
    btn.dataset.swatchInitialized = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const card = btn.closest('.product-card-item');
      if (!card) return;

      // Toggle active class among siblings
      const row = btn.closest('.product-card-swatches-row');
      if (row) {
        row.querySelectorAll('.swatch-btn').forEach(s => s.classList.remove('is-active'));

        // Manage swatch-selected class to handle hover state correctly
        const firstSwatch = row.querySelector('.swatch-btn');
        if (btn === firstSwatch) {
          card.classList.remove('swatch-selected');
        } else {
          card.classList.add('swatch-selected');
        }
      }
      btn.classList.add('is-active');

      // Update image with smooth fade transition
      const imageUrl = btn.getAttribute('data-image-url');
      const img = card.querySelector('.product-card-img:not(.product-card-img--secondary)');
      if (imageUrl && img && img.src !== imageUrl) {
        img.style.opacity = '0';
        setTimeout(() => {
          img.src = imageUrl;
          if (img.srcset) {
            img.srcset = ''; // Clear srcset to force showing the new specific image
          }
          img.onload = () => {
            img.style.opacity = '';
          };
          // Fallback if onload doesn't fire
          setTimeout(() => {
            img.style.opacity = '';
          }, 300);
        }, 150);
      }

      // Update link URL with variant ID
      const variantId = btn.getAttribute('data-variant-id');
      const links = card.querySelectorAll('.product-card-image-link, .product-card-title a');
      links.forEach(link => {
        let baseHref = link.getAttribute('data-base-href') || link.getAttribute('href');
        if (!link.getAttribute('data-base-href')) {
          link.setAttribute('data-base-href', baseHref);
        }
        // Strip out existing variant parameter if any
        baseHref = baseHref.split('?')[0];
        if (variantId) {
          link.setAttribute('href', `${baseHref}?variant=${variantId}`);
        } else {
          link.setAttribute('href', baseHref);
        }
      });
    });
  });

  // 4. Card Option Selector & Variant Resolver Logic
  const cardItems = document.querySelectorAll('.product-card-item');
  cardItems.forEach(card => {
    if (card.dataset.selectorsInitialized) return;
    card.dataset.selectorsInitialized = 'true';

    let variants = [];
    let options = [];
    try {
      variants = JSON.parse(card.dataset.variants || '[]');
      options = JSON.parse(card.dataset.options || '[]');
    } catch (e) {
      // Safely ignore if card has no variants
    }

    if (variants.length === 0 || options.length === 0) return;

    let colorPos = null;
    let sizePos = null;

    options.forEach(opt => {
      const name = opt.name.toLowerCase();
      if (name === 'color' || name === 'colour') {
        colorPos = `option${opt.position}`;
      } else if (name === 'size' || name === 'talla') {
        sizePos = `option${opt.position}`;
      }
    });

    const updateSelectedVariant = () => {
      const activeColorBtn = card.querySelector('.swatch-btn.is-active');
      const activeSizeBtn = card.querySelector('.size-pill-btn.is-active');

      const selectedColor = activeColorBtn ? activeColorBtn.getAttribute('title') : null;
      const selectedSize = activeSizeBtn ? activeSizeBtn.getAttribute('data-size') : null;

      const needsColorSelection = !!colorPos;
      const needsSizeSelection = !!sizePos;

      const colorSelected = !needsColorSelection || !!selectedColor;
      const sizeSelected = !needsSizeSelection || !!selectedSize;

      const addBtns = card.querySelectorAll('.product-card-add-btn');

      if (colorSelected && sizeSelected) {
        // Find matching variant
        const matchedVariant = variants.find(variant => {
          let match = true;
          if (colorPos && variant[colorPos] !== selectedColor) match = false;
          if (sizePos && variant[sizePos] !== selectedSize) match = false;
          return match;
        });

        if (matchedVariant) {
          addBtns.forEach(btn => {
            btn.setAttribute('data-variant-id', matchedVariant.id);
            btn.classList.remove('quick-add-trigger');
            if (matchedVariant.available) {
              btn.textContent = 'Añadir al carrito';
              btn.disabled = false;
            } else {
              btn.textContent = 'Agotado';
              btn.disabled = true;
            }
          });
          card.setAttribute('data-variant-id', matchedVariant.id);
        } else {
          // Combination unavailable
          addBtns.forEach(btn => {
            btn.textContent = 'No disponible';
            btn.disabled = true;
            btn.classList.remove('quick-add-trigger');
          });
        }
      } else {
        // Selections incomplete
        addBtns.forEach(btn => {
          btn.textContent = 'Ver opciones';
          btn.disabled = false;
          btn.classList.add('quick-add-trigger');
        });
      }
    };

    // Attach click listeners to size buttons
    const sizeBtns = card.querySelectorAll('.size-pill-btn');
    sizeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const wasActive = btn.classList.contains('is-active');
        sizeBtns.forEach(b => b.classList.remove('is-active'));

        if (wasActive) {
          // Deselect size
          btn.classList.remove('is-active');
        } else {
          btn.classList.add('is-active');
        }

        updateSelectedVariant();
      });
    });

    // Hook color swatch clicks inside this card to trigger variant update
    const swatchBtns = card.querySelectorAll('.swatch-btn');
    swatchBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(updateSelectedVariant, 50);
      });
    });
  });
}

/**
 * Helper function to show a sleek temporary toast notification
 */
function showToast(message) {
  let toast = document.querySelector('.theme-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'theme-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-active');

  // Reset existing timeouts
  if (window.toastTimeout) clearTimeout(window.toastTimeout);

  window.toastTimeout = setTimeout(() => {
    toast.classList.remove('is-active');
  }, 2200);
}

/**
 * Initializes interactive filters, accordions and layout grid switches for the Collection page
 */
function initCollectionFilters() {
  // 1b. Sidebar Categories Nested Menu Toggles
  const categoriesContainer = document.getElementById('FilterContent-categories');
  if (categoriesContainer && !categoriesContainer.dataset.initialized) {
    categoriesContainer.dataset.initialized = 'true';
    categoriesContainer.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('.sidebar-category-toggle');
      if (!toggleBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const parent = toggleBtn.closest('.sidebar-category-item');
      const submenu = parent ? parent.querySelector('.sidebar-category-submenu') : null;
      const plusIcon = toggleBtn.querySelector('.toggle-icon-plus');

      if (submenu) {
        const isOpen = submenu.style.display !== 'none';
        if (isOpen) {
          submenu.style.display = 'none';
          if (plusIcon) plusIcon.textContent = '+';
          toggleBtn.setAttribute('aria-expanded', 'false');
        } else {
          submenu.style.display = 'block';
          if (plusIcon) plusIcon.textContent = '−';
          toggleBtn.setAttribute('aria-expanded', 'true');
        }

        // Force parent accordion height calculation update
        const filterContent = toggleBtn.closest('.filter-group-content');
        if (filterContent && filterContent.style.maxHeight !== '0px' && filterContent.style.maxHeight !== '') {
          filterContent.style.maxHeight = 'none';
          filterContent.style.maxHeight = filterContent.scrollHeight + 'px';
        }
      }
    });
  }

  // 1. Sidebar Collapsible Accordions
  const filterHeaders = document.querySelectorAll('.filter-group-header');
  filterHeaders.forEach(header => {
    // Set initial maxHeight for open accordions so they transitions smoothly
    const content = header.nextElementSibling;
    if (content && !header.classList.contains('is-closed')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    header.addEventListener('click', (e) => {
      e.preventDefault();
      const content = header.nextElementSibling;
      const isClosed = header.classList.toggle('is-closed');
      header.setAttribute('aria-expanded', isClosed ? 'false' : 'true');

      if (content) {
        if (isClosed) {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.marginTop = '0px';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
          content.style.marginTop = '0.8rem';
        }
      }
    });
  });

  // 2. Grid Column Layout Switches
  const gridSwitches = document.querySelectorAll('.grid-switch-btn');
  const productsGrid = document.getElementById('CollectionProductsGrid');

  if (productsGrid && gridSwitches.length > 0) {
    gridSwitches.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        // Remove active class from all switches
        gridSwitches.forEach(s => s.classList.remove('is-active'));

        // Add active class to clicked switch
        btn.classList.add('is-active');

        // Read columns count
        const cols = btn.getAttribute('data-cols');

        // Reset classes
        productsGrid.classList.remove('cols-1', 'cols-2', 'cols-3', 'cols-4');
        productsGrid.classList.add(`cols-${cols}`);
      });
    });

    // Automatically set default view to 2 columns on mobile devices initially
    if (window.innerWidth <= 768) {
      productsGrid.classList.remove('cols-1', 'cols-2', 'cols-3', 'cols-4');
      productsGrid.classList.add('cols-2');

      gridSwitches.forEach(s => s.classList.remove('is-active'));
      const mobileDefaultSwitch = document.querySelector('.grid-switch-btn.cols-2');
      if (mobileDefaultSwitch) {
        mobileDefaultSwitch.classList.add('is-active');
      }
    }
  }

  // 3. Custom Premium Sorting Dropdown Selector
  const customSelect = document.getElementById('CustomSortDropdown');
  if (customSelect) {
    const trigger = customSelect.querySelector('.custom-select-trigger');
    const label = customSelect.querySelector('.custom-select-label');
    const options = customSelect.querySelectorAll('.custom-select-option');
    const nativeSelect = document.getElementById('SortBy');

    if (trigger && options.length > 0 && nativeSelect) {
      // Toggle dropdown open/close
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = customSelect.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      // Handle selecting an option
      options.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Remove selected class from all options
          options.forEach(opt => opt.classList.remove('is-selected'));

          // Add selected class to current option
          option.classList.add('is-selected');

          // Read value and label
          const val = option.getAttribute('data-value');
          const optionText = option.querySelector('span').textContent;

          // Update trigger label
          label.textContent = optionText;

          // Sync with hidden native select
          nativeSelect.value = val;

          // Trigger change event to fire Shopify's dynamic reactive sorting
          const event = new Event('change', { bubbles: true });
          nativeSelect.dispatchEvent(event);

          // Close custom dropdown
          customSelect.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });
      });

      // Close dropdown if clicking anywhere else outside
      document.addEventListener('click', (e) => {
        if (!customSelect.contains(e.target)) {
          customSelect.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  // 4. Double Knob Price Slider Calculations & Synchronization
  const dualSliders = document.querySelectorAll('.dual-range-slider');
  dualSliders.forEach(slider => {
    const rangeMin = slider.querySelector('.range-min');
    const rangeMax = slider.querySelector('.range-max');
    const track = slider.querySelector('.slider-track');
    const container = slider.closest('.price-slider-container');
    if (!container) return;
    const inputMin = container.querySelector('.price-input-min');
    const inputMax = container.querySelector('.price-input-max');

    if (!rangeMin || !rangeMax || !track || !inputMin || !inputMax) return;

    const rangeMaxVal = parseFloat(rangeMin.max) || 200;

    const updateSliderUI = () => {
      let minVal = parseFloat(rangeMin.value);
      let maxVal = parseFloat(rangeMax.value);

      // Prevent thumbs from crossing each other
      if (maxVal - minVal < 0) {
        rangeMin.value = maxVal;
        minVal = maxVal;
      }

      // Sync display inputs
      inputMin.value = minVal;
      inputMax.value = maxVal;

      // Update tracks highlight width and offsets
      const leftPct = (minVal / rangeMaxVal) * 100;
      const rightPct = 100 - (maxVal / rangeMaxVal) * 100;
      track.style.left = leftPct + '%';
      track.style.right = rightPct + '%';
    };

    // Listen to changes on range handles (continuous update)
    rangeMin.addEventListener('input', updateSliderUI);
    rangeMax.addEventListener('input', updateSliderUI);

    // Initial load
    updateSliderUI();
  });

  // 5. Automatic form submission for Filter Forms
  const filtersForm = document.getElementById('CollectionFiltersForm');
  if (filtersForm) {
    // Bridge external SortBy select changes to the filter form
    const nativeSort = document.getElementById('SortBy');
    const mobileSortSelect = document.getElementById('MobileSortBy');

    if (nativeSort) {
      nativeSort.addEventListener('change', () => {
        const sortInput = filtersForm.querySelector('input[name="sort_by"]');
        if (sortInput) {
          sortInput.value = nativeSort.value;
        }
        if (mobileSortSelect) {
          mobileSortSelect.value = nativeSort.value;
        }
        filtersForm.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (mobileSortSelect) {
      mobileSortSelect.addEventListener('change', () => {
        const sortInput = filtersForm.querySelector('input[name="sort_by"]');
        if (sortInput) {
          sortInput.value = mobileSortSelect.value;
        }
        if (nativeSort) {
          nativeSort.value = mobileSortSelect.value;
          // Sync desktop custom select UI labels if present
          const customSelect = document.getElementById('CustomSortDropdown');
          if (customSelect) {
            const label = customSelect.querySelector('.custom-select-label');
            const activeOption = customSelect.querySelector(`.custom-select-option[data-value="${mobileSortSelect.value}"]`);
            if (label && activeOption) {
              label.textContent = activeOption.querySelector('span').textContent;
              customSelect.querySelectorAll('.custom-select-option').forEach(opt => opt.classList.remove('is-selected'));
              activeOption.classList.add('is-selected');
            }
          }
        }
        filtersForm.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // We listen to the "change" event! Checkboxes & standard select trigger "change"
    // Price range inputs will also trigger "change" when the user RELEASES the slider handles!
    filtersForm.addEventListener('change', () => {
      // Sync sort_by if SortBy native select exists and has a value
      const sortInput = filtersForm.querySelector('input[name="sort_by"]');
      if (nativeSort && sortInput) {
        sortInput.value = nativeSort.value;
      }

      // Create parameters object from Form data
      const formData = new FormData(filtersForm);
      const params = new URLSearchParams();

      for (const [key, val] of formData.entries()) {
        if (val) {
          params.append(key, val);
        }
      }

      // Automatically reload page via AJAX with the filters applied!
      const targetSearch = params.toString();
      const targetUrl = window.location.pathname + (targetSearch ? '?' + targetSearch : '');
      updateCollectionPage(targetUrl);
    });
  }

  // 6. Mobile Drawer Open/Close Interaction
  const mobileTrigger = document.getElementById('MobileFiltersTrigger');
  const drawerSidebar = document.querySelector('.collection-filters-sidebar');
  const drawerOverlay = document.getElementById('CollectionDrawerOverlay');
  const drawerCloseBtn = document.getElementById('MobileDrawerClose');

  if (mobileTrigger && drawerSidebar && drawerOverlay) {
    const openDrawer = () => {
      drawerSidebar.classList.add('is-open');
      drawerOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent body scroll while viewing drawer
    };

    const closeDrawer = () => {
      drawerSidebar.classList.remove('is-open');
      drawerOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore body scroll
    };

    mobileTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });

    if (drawerCloseBtn) {
      drawerCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    }

    if (!drawerOverlay.dataset.overlayListenerAdded) {
      drawerOverlay.addEventListener('click', closeDrawer);
      drawerOverlay.dataset.overlayListenerAdded = 'true';
    }
  }

  // 7. AJAX Pagination Click Handlers
  const paginationLinks = document.querySelectorAll('.pagination-item');
  paginationLinks.forEach(link => {
    if (link.tagName === 'A') {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetUrl = link.getAttribute('href');
        if (targetUrl && targetUrl !== '#') {
          updateCollectionPage(targetUrl);
        }
      });
    }
  });

  // 7b. AJAX Pagination - Load More & Infinite Scroll
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const infiniteScrollWrapper = document.querySelector('.collection-infinite-scroll-wrapper');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      loadNextCollectionPageAJAX(loadMoreBtn);
    });
  }

  if (infiniteScrollWrapper) {
    if (window.infiniteScrollObserver) {
      window.infiniteScrollObserver.disconnect();
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const nextUrl = infiniteScrollWrapper.getAttribute('data-next-url');
          if (nextUrl && !infiniteScrollWrapper.classList.contains('is-loading')) {
            loadNextCollectionPageAJAX(infiniteScrollWrapper);
          }
        }
      });
    }, {
      rootMargin: '200px'
    });
    observer.observe(infiniteScrollWrapper);
    window.infiniteScrollObserver = observer;
  }

  // 8. Global Escape Key Listener for Filters Drawer
  if (!window.filtersEscapeListenerAdded) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activeSidebar = document.querySelector('.collection-filters-sidebar.is-open');
        if (activeSidebar) {
          activeSidebar.classList.remove('is-open');
          const overlay = document.getElementById('CollectionDrawerOverlay');
          if (overlay) overlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
    });
    window.filtersEscapeListenerAdded = true;
  }
}

/**
 * Updates the collection page dynamically using AJAX
 * @param {string} targetUrl The target URL containing filter search parameters
 * @param {boolean} skipPushState Set to true to avoid pushing history state (e.g. for popstate)
 */
function updateCollectionPage(targetUrl, skipPushState = false) {
  const wrapper = document.querySelector('.collection-page-wrapper');
  if (!wrapper) return;

  // Visual feedback: reduce grid opacity and disable mouse interactions
  const grid = document.getElementById('CollectionProductsGrid');
  if (grid) {
    grid.style.opacity = '0.5';
    grid.style.pointerEvents = 'none';
  }

  fetch(targetUrl)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newWrapperContent = doc.querySelector('.collection-page-wrapper');
      if (newWrapperContent) {
        const oldDrawer = document.querySelector('.collection-filters-sidebar');
        const newDrawer = doc.querySelector('.collection-filters-sidebar');
        const oldProducts = document.querySelector('.collection-products-panel');
        const newProducts = doc.querySelector('.collection-products-panel');

        // Capture scroll position of the drawer before swap
        const drawerScrollTop = oldDrawer ? oldDrawer.scrollTop : 0;

        // Save accordion states by group ID
        const accordionStates = {};
        document.querySelectorAll('.filter-group-wrapper').forEach(group => {
          const groupId = group.id;
          const header = group.querySelector('.filter-group-header');
          if (groupId && header) {
            accordionStates[groupId] = !header.classList.contains('is-closed');
          }
        });

        if (oldDrawer && newDrawer && oldProducts && newProducts) {
          // Swap inner content of filters sidebar and products panel separately
          // to preserve the outer elements, preventing transition triggers or losing open class.
          oldDrawer.innerHTML = newDrawer.innerHTML;
          oldDrawer.scrollTop = drawerScrollTop;
          oldProducts.innerHTML = newProducts.innerHTML;
        } else {
          // Fallback to swapping the entire wrapper content
          wrapper.innerHTML = newWrapperContent.innerHTML;
        }

        // Restore accordion states
        document.querySelectorAll('.filter-group-wrapper').forEach(group => {
          const groupId = group.id;
          if (groupId && groupId in accordionStates) {
            const isOpen = accordionStates[groupId];
            const header = group.querySelector('.filter-group-header');
            const content = group.querySelector('.filter-group-content');
            if (header && content) {
              if (isOpen) {
                header.classList.remove('is-closed');
                header.setAttribute('aria-expanded', 'true');
                content.style.maxHeight = '';
                content.style.opacity = '';
                content.style.marginTop = '';
              } else {
                header.classList.add('is-closed');
                header.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = '0px';
                content.style.opacity = '0';
                content.style.marginTop = '0px';
              }
            }
          }
        });

        if (!skipPushState) {
          history.pushState({ path: targetUrl }, '', targetUrl);
        }

        // Re-initialize event listeners and animations for all elements inside the swapped content
        initCollectionFilters();
        initProductCards();
        initCartAjaxHandlers();
        initScrollAnimations();
      }
    })
    .catch(error => {
      console.error('Error fetching collection filters:', error);
      if (grid) {
        grid.style.opacity = '1';
        grid.style.pointerEvents = 'auto';
      }
    });
}

/**
 * Loads the next page of products asynchronously via AJAX and appends them
 * @param {HTMLElement} element Either the "Cargar más" button or the infinite scroll wrapper
 */
function loadNextCollectionPageAJAX(element) {
  const isLoadMore = element.classList.contains('load-more-btn');
  const nextUrl = element.getAttribute(isLoadMore ? 'data-next-url' : 'data-next-url');
  if (!nextUrl) return;

  let wrapper = isLoadMore ? element.closest('.collection-load-more-wrapper') : element;
  if (!wrapper) return;

  wrapper.classList.add('is-loading');
  const spinner = wrapper.querySelector('.load-more-spinner');
  if (spinner) spinner.classList.remove('hidden');
  if (isLoadMore) element.style.display = 'none';

  fetch(nextUrl)
    .then(response => {
      if (!response.ok) throw new Error('Failed to load next page');
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Append products to grid
      const newGrid = doc.getElementById('CollectionProductsGrid');
      const currentGrid = document.getElementById('CollectionProductsGrid');
      if (newGrid && currentGrid) {
        const newProducts = Array.from(newGrid.children);
        newProducts.forEach(product => {
          currentGrid.appendChild(product);
        });
      }

      // Replace pagination element
      const oldPagination = document.getElementById('CollectionPagination');
      const newPagination = doc.getElementById('CollectionPagination');
      if (oldPagination && newPagination) {
        oldPagination.outerHTML = newPagination.outerHTML;
      } else if (oldPagination) {
        oldPagination.remove();
      }

      // Re-initialize cards, cart, and scroll animations
      initProductCards();
      initCartAjaxHandlers();
      if (typeof initScrollAnimations === 'function') initScrollAnimations();
      // Re-initialize collection filter listeners so the new pagination trigger is bound
      initCollectionFilters();
    })
    .catch(error => {
      console.error('AJAX pagination error:', error);
      wrapper.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');
      if (isLoadMore) element.style.display = 'inline-block';
    });
}

// Handle browser navigation (back/forward arrows)
if (!window.filtersPopstateListenerAdded) {
  window.addEventListener('popstate', () => {
    if (document.querySelector('.collection-page-wrapper')) {
      updateCollectionPage(window.location.href, true);
    }
  });
  window.filtersPopstateListenerAdded = true;
}

/**
 * Initializes the AJAX Add to Cart and Line Item removal event listeners
 */
function initCartAjaxHandlers() {
  // Select all add-to-cart buttons
  const addBtns = document.querySelectorAll('.product-card-add-btn, .product-card-add-btn-icon-always, .rec-card-add-btn-ajax, .list-action-btn.cart-btn');

  addBtns.forEach(btn => {
    // Prevent duplicate listeners on AJAX buttons
    if (btn.dataset.ajaxInitialized) return;
    btn.dataset.ajaxInitialized = 'true';

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Gate de personalizacion. Cubre las tarjetas de coleccion, las de la vista de lista
      // y los upsells del carrito y del cajon: todos anaden con solo id y quantity.
      if (window.atelierGatePersonalizado(btn)) return;

      const insideSearchDrawer = btn.closest('#SearchDrawer');

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('No variant ID found on add-to-cart button');
        return;
      }

      const isIconOnly = btn.classList.contains('product-card-add-btn-icon-always');
      let originalContent;

      // Loading state feedback
      if (isIconOnly) {
        originalContent = btn.innerHTML;
        btn.innerHTML = `
          <svg style="animation: spin 1s linear infinite;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="20" height="20">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25; fill: none;"></circle>
            <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        `;
      } else {
        originalContent = btn.textContent;
        btn.textContent = 'Agregando...';
      }

      btn.disabled = true;

      // Shopify AJAX Add to Cart POST request
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js?skip_sync=1', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({
          'id': variantId,
          'quantity': 1
        }).toString()
      })
        .then(res => {
          if (!res.ok) {
            throw new Error('Error adding product to cart');
          }
          return res.json();
        })
        .then(item => {
          // Success state feedback
          if (isIconOnly) {
            btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" width="20" height="20">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          `;
          } else {
            btn.textContent = '¡Añadido!';
          }

          if (insideSearchDrawer) {
            const searchDrawerCloseBtn = document.querySelector('#SearchDrawer .search-drawer-close');
            if (searchDrawerCloseBtn) {
              searchDrawerCloseBtn.click();
            }
          }

          // Dynamically refresh drawer HTML and open it or refresh cart page if on main cart page!
          if (window.refreshCartPageContent) {
            window.refreshCartPageContent();
          } else {
            refreshCartDrawer(true); // pass true to open the drawer after refreshing
          }

          // Revert button status back to normal after a short delay
          setTimeout(() => {
            if (isIconOnly) {
              btn.innerHTML = originalContent;
            } else {
              btn.textContent = originalContent;
            }
            btn.disabled = false;
          }, 1500);
        })
        .catch(err => {
          console.error('AJAX cart error:', err);
          showToast('Error al añadir al carrito. Por favor, inténtelo de nuevo.');
          if (isIconOnly) {
            btn.innerHTML = originalContent;
          } else {
            btn.textContent = originalContent;
          }
          btn.disabled = false;
        });
    });
  });

  // Handle Dynamic Line Item Removal
  const removeBtns = document.querySelectorAll('.cart-item-remove-btn');
  removeBtns.forEach(btn => {
    if (btn.closest('cart-drawer-items')) return; // Let custom element in cart-items-block.liquid handle it
    if (btn.dataset.ajaxInitialized) return;
    btn.dataset.ajaxInitialized = 'true';

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const line = btn.getAttribute('data-line');
      if (!line) return;

      const itemRow = btn.closest('.cart-drawer-item');
      if (itemRow) {
        // Smooth collapse and slide out animation
        itemRow.style.transition = 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
        itemRow.style.opacity = '0';
        itemRow.style.transform = 'translateX(50px)';
        itemRow.style.pointerEvents = 'none';
        itemRow.style.maxHeight = itemRow.offsetHeight + 'px';
        setTimeout(() => {
          itemRow.style.maxHeight = '0px';
          itemRow.style.paddingTop = '0px';
          itemRow.style.paddingBottom = '0px';
          itemRow.style.borderBottomWidth = '0px';
          itemRow.style.marginBottom = '0px';
        }, 100);
      }

      // Resolve current active section ID dynamically
      const currentDrawer = document.getElementById('CartDrawer');
      const sectionElement = currentDrawer ? currentDrawer.closest('.shopify-section') : null;
      const activeSectionId = sectionElement ? sectionElement.id.replace('shopify-section-', '') : 'cart-drawer';

      // Fire fetch request immediately in parallel to the animation, requesting the active cart section
      const fetchPromise = fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js?skip_sync=1', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          'line': parseInt(line),
          'quantity': 0,
          'sections': activeSectionId
        })
      }).then(res => {
        if (!res.ok) throw new Error('Error removing item');
        return res.json();
      });

      // Wait 300ms for the animation to complete, then process the fetch response
      setTimeout(() => {
        fetchPromise
          .then(cart => {
            refreshCartDrawer(false, cart);
            if (window.location.pathname === '/cart' && window.refreshCartPageContent) {
              window.refreshCartPageContent();
            }
          })
          .catch(err => {
            console.error('AJAX remove error:', err);
            if (itemRow) {
              itemRow.style.opacity = '';
              itemRow.style.pointerEvents = '';
              itemRow.style.transform = '';
              itemRow.style.maxHeight = '';
              itemRow.style.paddingTop = '';
              itemRow.style.paddingBottom = '';
              itemRow.style.borderBottomWidth = '';
              itemRow.style.marginBottom = '';
            }
            refreshCartDrawer(false); // Fallback refresh
          });
      }, 300);
    });
  });

  // Handle Drawer Quantity Selectors
  const drawerSelectors = document.querySelectorAll('#CartDrawer .cart-qty-selector');
  drawerSelectors.forEach(selector => {
    if (selector.dataset.qtyInitialized) return;
    selector.dataset.qtyInitialized = 'true';

    const minusBtn = selector.querySelector('.qty-minus');
    const plusBtn = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');
    if (!input) return;

    const lineIndex = input.getAttribute('data-line');

    const updateQuantity = (newVal) => {
      if (newVal < 0) newVal = 0;

      // Check inventory limits
      const invManagement = input.getAttribute('data-inventory-management');
      const invPolicy = input.getAttribute('data-inventory-policy');
      const invQuantity = parseInt(input.getAttribute('data-inventory-quantity'));

      if (invManagement && invPolicy !== 'continue' && !isNaN(invQuantity)) {
        if (newVal > invQuantity) {
          newVal = invQuantity;
          input.value = newVal;
          if (typeof showToast !== 'undefined') {
            showToast('No hay más stock disponible.');
          } else {
            alert('No hay más stock disponible.');
          }
          return;
        }
      }

      input.value = newVal;

      // Show loader
      selector.classList.add('is-loading');

      const itemRow = selector.closest('.cart-drawer-item');
      let delay = 0;
      if (newVal === 0 && itemRow) {
        delay = 300;
        // If removing, animate it out smoothly
        itemRow.style.transition = 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
        itemRow.style.opacity = '0';
        itemRow.style.transform = 'translateX(50px)';
        itemRow.style.pointerEvents = 'none';
        itemRow.style.maxHeight = itemRow.offsetHeight + 'px';
        setTimeout(() => {
          itemRow.style.maxHeight = '0px';
          itemRow.style.paddingTop = '0px';
          itemRow.style.paddingBottom = '0px';
          itemRow.style.borderBottomWidth = '0px';
          itemRow.style.marginBottom = '0px';
        }, 100);
      }

      // Resolve current active section ID dynamically
      const currentDrawer = document.getElementById('CartDrawer');
      const sectionElement = currentDrawer ? currentDrawer.closest('.shopify-section') : null;
      const activeSectionId = sectionElement ? sectionElement.id.replace('shopify-section-', '') : 'cart-drawer';

      // Fire fetch request immediately in parallel to the animation, requesting the active cart section
      const fetchPromise = fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: newVal,
          sections: activeSectionId
        })
      }).then(res => {
        if (!res.ok) throw new Error('Error updating drawer cart qty');
        return res.json();
      });

      const handleResponse = () => {
        fetchPromise
          .then(cart => {
            refreshCartDrawer(false, cart);
            if (window.location.pathname === '/cart' && window.refreshCartPageContent) {
              window.refreshCartPageContent();
            }
          })
          .catch(err => {
            console.error('AJAX qty update error:', err);
            refreshCartDrawer(false);
          });
      };

      if (delay > 0) {
        setTimeout(handleResponse, delay);
      } else {
        handleResponse();
      }
    };

    if (minusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentVal = parseInt(input.value) || 0;
        if (currentVal > 0) {
          updateQuantity(currentVal - 1);
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentVal = parseInt(input.value) || 0;
        updateQuantity(currentVal + 1);
      });
    }

    input.addEventListener('change', () => {
      const newVal = parseInt(input.value);
      if (!isNaN(newVal)) {
        updateQuantity(newVal);
      }
    });
  });
}

/**
 * Dynamically refreshes the Shopify Cart Drawer section via the Section Rendering API
 */
function refreshCartDrawer(openDrawerAfter = false, preRenderedHtml = null) {
  const currentDrawer = document.getElementById('CartDrawer');
  const sectionElement = currentDrawer ? currentDrawer.closest('.shopify-section') : null;
  const sectionId = sectionElement ? sectionElement.id.replace('shopify-section-', '') : 'cart-drawer';
  const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

  // If opening requested, open immediately to start the CSS slide-in animation on stable DOM
  if (openDrawerAfter && currentDrawer) {
    currentDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const recPanel = document.getElementById('CartDrawerRecs');
    if (recPanel) recPanel.classList.remove('is-closed');
  }

  const wasOpen = currentDrawer && currentDrawer.classList.contains('is-open');

  const oldSection = sectionElement || document.getElementById(`shopify-section-${sectionId}`);
  if (oldSection && wasOpen) {
    oldSection.classList.add('is-updating');
  }

  const handleJson = (json) => {
    const html = json[sectionId] || (json.sections && json.sections[sectionId]);
    if (!html) {
      if (oldSection) oldSection.classList.remove('is-updating');
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newSection = doc.getElementById(`shopify-section-${sectionId}`) || doc.querySelector('.shopify-section');

    if (newSection && oldSection) {
      const oldDrawer = document.getElementById('CartDrawer');
      const oldRecs = document.getElementById('CartDrawerRecs');
      const oldMain = document.getElementById('CartDrawerMain');
      const oldWrapper = oldSection.querySelector('.cart-drawer-wrapper');

      const newDrawer = newSection.querySelector('#CartDrawer');
      const newRecs = newSection.querySelector('#CartDrawerRecs');
      const newMain = newSection.querySelector('#CartDrawerMain');
      const newWrapper = newSection.querySelector('.cart-drawer-wrapper');

      const canUpdateInPlace = oldDrawer && newDrawer && oldRecs && newRecs && oldMain && newMain && oldWrapper && newWrapper;

      if (canUpdateInPlace) {
        // Capture active tab state before update
        const activeTab = oldDrawer.querySelector('.cart-drawer-tab-btn.is-active');
        const activeTabId = activeTab ? activeTab.getAttribute('data-tab') : null;

        // Swap panel contents in place to preserve parent DOM nodes (transition properties remain stable)
        oldRecs.innerHTML = newRecs.innerHTML;
        oldMain.innerHTML = newMain.innerHTML;

        // Sync outer wrapper classes (color scheme, empty state)
        oldWrapper.className = newWrapper.className;

        // Sync discount attribute
        if (newDrawer.hasAttribute('data-active-discount')) {
          oldDrawer.setAttribute('data-active-discount', newDrawer.getAttribute('data-active-discount'));
        } else {
          oldDrawer.removeAttribute('data-active-discount');
        }

        // Restore active tab
        if (activeTabId) {
          const restoredTab = oldMain.querySelector(`.cart-drawer-tab-btn[data-tab="${activeTabId}"]`);
          const restoredPanel = oldMain.querySelector(`#AddonPanel-${activeTabId}`);
          if (restoredTab) restoredTab.classList.add('is-active');
          if (restoredPanel) restoredPanel.classList.add('is-active');
        }

        // Re-initialize drawer interactivity
        initCartDrawer();
        initCartAjaxHandlers();
        initCartCoupon();
        updateCartBadges();

        // Ensure visual classes are in correct state
        if (wasOpen || openDrawerAfter) {
          oldDrawer.classList.add('is-open');
        }
      } else {
        // Fallback to full swap if elements are missing
        const activeTab = oldDrawer ? oldDrawer.querySelector('.cart-drawer-tab-btn.is-active') : null;
        const activeTabId = activeTab ? activeTab.getAttribute('data-tab') : null;

        if (wasOpen || openDrawerAfter) {
          if (newDrawer) newDrawer.classList.add('is-open');
        }

        if (activeTabId && newSection) {
          const newTab = newSection.querySelector(`.cart-drawer-tab-btn[data-tab="${activeTabId}"]`);
          const newPanel = newSection.querySelector(`#AddonPanel-${activeTabId}`);
          if (newTab) newTab.classList.add('is-active');
          if (newPanel) newPanel.classList.add('is-active');
        }

        oldSection.innerHTML = newSection.innerHTML;

        initCartDrawer();
        initCartAjaxHandlers();
        initCartCoupon();
        updateCartBadges();

        const restoredDrawer = document.getElementById('CartDrawer');
        if (restoredDrawer) {
          if (wasOpen || openDrawerAfter) {
            requestAnimationFrame(() => {
              restoredDrawer.classList.add('is-open');
              document.body.style.overflow = 'hidden';
              const recPanel = document.getElementById('CartDrawerRecs');
              if (recPanel) recPanel.classList.remove('is-closed');
            });
          }
        }
      }

      // Fade back in smoothly
      setTimeout(() => {
        oldSection.classList.remove('is-updating');
      }, 50);
    } else {
      if (oldSection) oldSection.classList.remove('is-updating');
    }
  };

  if (preRenderedHtml) {
    handleJson(preRenderedHtml);
  } else {
    fetch(`${rootUrl}?sections=${sectionId}`)
      .then(res => res.json())
      .then(json => {
        handleJson(json);
      })
      .catch(err => {
        console.error('Error refreshing cart drawer section:', err);
        if (oldSection) oldSection.classList.remove('is-updating');
      });
  }
}

/**
 * Fetches the current cart state and updates all header and sticky badge counts dynamically
 */
function updateCartBadges() {
  const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

  fetch(rootUrl + 'cart.js')
    .then(res => res.json())
    .then(cart => {
      let count = 0;
      if (cart.items) {
        cart.items.forEach(item => {
          const isHidden = (item.properties && (item.properties._cart_hidden === 'true' || item.properties._cart_hidden === true || item.properties.cart_hidden)) || (window.cartHiddenVariantIds && window.cartHiddenVariantIds.includes(item.variant_id));
          if (!isHidden) {
            count += item.quantity;
          }
        });
      } else {
        count = cart.item_count;
      }

      const headerBadges = document.querySelectorAll('.cart-badge, .cart-count-badge, #CartCount');
      const stickyBadges = document.querySelectorAll('#MobileStickyCartCount');

      headerBadges.forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });

      stickyBadges.forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
    })
    .catch(err => {
      console.error('Error updating cart badges:', err);
    });
}

function showTemporaryBanner(msgContainer, savedCoupon, isDrawer) {
  if (!msgContainer) return;

  if (msgContainer.fadeTimeout) clearTimeout(msgContainer.fadeTimeout);
  if (msgContainer.hideTimeout) clearTimeout(msgContainer.hideTimeout);

  const styleMargin = isDrawer ? 'margin-bottom: 12px;' : 'margin-top: 10px;';
  msgContainer.innerHTML = `
    <div class="coupon-activated-banner" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; ${styleMargin} padding: 10px 14px; background-color: #f0fdf4; border: 1px solid #bbf7d0; border-radius: max(0px, calc(var(--layout-border-radius) - 12px)); transition: opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1), transform 0.5s cubic-bezier(0.16, 1, 0.3, 1); transform: translateY(-10px); opacity: 0;">
      <span style="display: flex; align-items: center; gap: 6px; color: #16a34a; font-size: 0.85rem; font-weight: 500;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" width="16" height="16" style="flex-shrink: 0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
        Cupón <strong>"${savedCoupon}"</strong> activado
      </span>
      <button type="button" class="clear-coupon-btn" style="background: none; border: none; color: #dc2626; cursor: pointer; font-size: 0.8rem; font-weight: 600; padding: 2px 6px; text-decoration: underline; transition: color 0.2s;" onmouseover="this.style.color='#991b1b'" onmouseout="this.style.color='#dc2626'">Quitar</button>
    </div>
  `;
  msgContainer.style.display = 'block';

  const banner = msgContainer.querySelector('.coupon-activated-banner');
  if (banner) {
    void banner.offsetWidth;
    banner.style.opacity = '1';
    banner.style.transform = 'translateY(0)';

    msgContainer.fadeTimeout = setTimeout(() => {
      banner.style.opacity = '0';
      banner.style.transform = 'translateY(-10px)';
      msgContainer.hideTimeout = setTimeout(() => {
        msgContainer.style.display = 'none';
        msgContainer.innerHTML = '';
      }, 500);
    }, 4000);
  }
}

function updateCouponUI() {
  const drawerEl = document.getElementById('CartDrawer');
  const pageEl = document.querySelector('.cart-page-wrapper');

  let serverDiscount = null;
  if (drawerEl && drawerEl.hasAttribute('data-active-discount')) {
    serverDiscount = drawerEl.getAttribute('data-active-discount') || '';
  } else if (pageEl && pageEl.hasAttribute('data-active-discount')) {
    serverDiscount = pageEl.getAttribute('data-active-discount') || '';
  }

  if (serverDiscount !== null) {
    const currentSessionCoupon = sessionStorage.getItem('cart_discount_code') || '';
    if (!serverDiscount && currentSessionCoupon) {
      sessionStorage.removeItem('cart_discount_code');
      sessionStorage.removeItem('last_shown_coupon');
    } else if (serverDiscount && serverDiscount !== currentSessionCoupon) {
      sessionStorage.setItem('cart_discount_code', serverDiscount);
    }
  }

  const savedCoupon = sessionStorage.getItem('cart_discount_code') || '';
  const lastShownCoupon = sessionStorage.getItem('last_shown_coupon') || '';
  const drawerCoupon = document.getElementById('CartCoupon');
  const pageCoupon = document.getElementById('CartPageCoupon');
  const drawerMsg = document.getElementById('CartDrawerCouponMessage');
  const pageMsg = document.getElementById('CartPageCouponMessage');

  // Sync inputs
  if (drawerCoupon) drawerCoupon.value = savedCoupon;
  if (pageCoupon) pageCoupon.value = savedCoupon;

  // Only show temporary confirmation banner if the coupon is newly activated
  if (savedCoupon !== lastShownCoupon) {
    if (savedCoupon) {
      if (drawerMsg) showTemporaryBanner(drawerMsg, savedCoupon, true);
      if (pageMsg) showTemporaryBanner(pageMsg, savedCoupon, false);
      sessionStorage.setItem('last_shown_coupon', savedCoupon);
    } else {
      sessionStorage.removeItem('last_shown_coupon');
      if (drawerMsg) {
        drawerMsg.style.display = 'none';
        drawerMsg.innerHTML = '';
      }
      if (pageMsg) {
        pageMsg.style.display = 'none';
        pageMsg.innerHTML = '';
      }
    }
  }

  // Sync applied coupon badges on cart and drawer products
  const badges = document.querySelectorAll('.applied-coupon-badge');
  badges.forEach(badge => {
    if (savedCoupon) {
      const codePlaceholder = badge.querySelector('.coupon-code-placeholder');
      if (codePlaceholder) codePlaceholder.textContent = savedCoupon;
      badge.style.display = 'inline-flex';
      badge.style.opacity = '0';
      void badge.offsetWidth;
      badge.style.opacity = '1';
    } else {
      badge.style.opacity = '0';
      setTimeout(() => {
        badge.style.display = 'none';
      }, 300);
    }
  });
}

/**
 * Restores and synchronizes discount code inputs across drawer and cart page,
 * persisting active coupons in sessionStorage and showing alerts.
 */
function initCartCoupon() {
  const drawerCoupon = document.getElementById('CartCoupon');
  const pageCoupon = document.getElementById('CartPageCoupon');

  // Synchronize inputs and status banners
  updateCouponUI();

  // Bind drawer coupon Save button
  const drawerSaveBtn = document.querySelector('#AddonPanel-coupon .overlay-btn-save');
  if (drawerSaveBtn && !drawerSaveBtn.dataset.couponBound) {
    drawerSaveBtn.dataset.couponBound = 'true';
    drawerSaveBtn.addEventListener('click', () => {
      if (drawerCoupon) {
        const val = drawerCoupon.value.trim();
        const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        if (val) {
          sessionStorage.setItem('cart_discount_code', val);
          fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: val })
          })
            .then(res => res.json())
            .then(() => {
              showToast('Cupón activado: ' + val);
              updateCouponUI();
              if (window.refreshCartDrawer) window.refreshCartDrawer(false);
            });
        } else {
          sessionStorage.removeItem('cart_discount_code');
          fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: '' })
          })
            .then(res => res.json())
            .then(() => {
              showToast('Cupón eliminado');
              updateCouponUI();
              if (window.refreshCartDrawer) window.refreshCartDrawer(false);
            });
        }
      }
    });
  }

  // Bind page coupon Apply button
  const pageApplyBtn = document.querySelector('.coupon-apply-btn');
  if (pageApplyBtn && !pageApplyBtn.dataset.couponBound) {
    pageApplyBtn.dataset.couponBound = 'true';
    pageApplyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (pageCoupon) {
        const val = pageCoupon.value.trim();
        const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        if (val) {
          sessionStorage.setItem('cart_discount_code', val);
          fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: val })
          })
            .then(res => res.json())
            .then(() => {
              showToast('Cupón activado: ' + val);
              updateCouponUI();
              if (window.refreshCartPageContent) window.refreshCartPageContent();
            });
        } else {
          sessionStorage.removeItem('cart_discount_code');
          fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: '' })
          })
            .then(res => res.json())
            .then(() => {
              showToast('Cupón eliminado');
              updateCouponUI();
              if (window.refreshCartPageContent) window.refreshCartPageContent();
            });
        }
      }
    });
  }

  // Add Enter key handlers for coupon inputs
  if (pageCoupon && !pageCoupon.dataset.enterBound) {
    pageCoupon.dataset.enterBound = 'true';
    pageCoupon.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (pageApplyBtn) pageApplyBtn.click();
      }
    });
  }

  if (drawerCoupon && !drawerCoupon.dataset.enterBound) {
    drawerCoupon.dataset.enterBound = 'true';
    drawerCoupon.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (drawerSaveBtn) drawerSaveBtn.click();
      }
    });
  }

  // Bind remove coupon button in summary
  const removeSummaryBtns = document.querySelectorAll('.remove-coupon-btn-summary');
  removeSummaryBtns.forEach(removeSummaryBtn => {
    if (removeSummaryBtn && !removeSummaryBtn.dataset.removeBound) {
      removeSummaryBtn.dataset.removeBound = 'true';
      removeSummaryBtn.addEventListener('click', (e) => {
        e.preventDefault();
        sessionStorage.removeItem('cart_discount_code');
        sessionStorage.removeItem('last_shown_coupon');
        const drawerCouponInput = document.getElementById('CartCoupon');
        const pageCouponInput = document.getElementById('CartPageCoupon');
        if (drawerCouponInput) drawerCouponInput.value = '';
        if (pageCouponInput) pageCouponInput.value = '';

        const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ discount: '' })
        })
          .then(res => res.json())
          .then(() => {
            showToast('Cupón eliminado');
            updateCouponUI();
            if (window.refreshCartPageContent) window.refreshCartPageContent();
            if (window.refreshCartDrawer) window.refreshCartDrawer(false);
          });
      });
    }
  });
}

// Global handler to clear coupon when clicking the banner "Quitar" button
document.addEventListener('click', (e) => {
  if (e.target && e.target.classList.contains('clear-coupon-btn')) {
    e.preventDefault();
    sessionStorage.removeItem('cart_discount_code');
    sessionStorage.removeItem('last_shown_coupon');
    const drawerCoupon = document.getElementById('CartCoupon');
    const pageCoupon = document.getElementById('CartPageCoupon');
    if (drawerCoupon) drawerCoupon.value = '';
    if (pageCoupon) pageCoupon.value = '';

    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    fetch(rootUrl + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(res => res.json())
      .then(() => {
        updateCouponUI();
        showToast('Cupón eliminado');
        if (window.refreshCartPageContent) {
          window.refreshCartPageContent();
        } else if (window.refreshCartDrawer) {
          window.refreshCartDrawer(false);
        }
      });
  }
});

// Intercept checkout form submissions to append the discount code
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!form) return;

  const actionAttr = form.getAttribute('action');
  if (typeof actionAttr === 'string') {
    // Only intercept checkout or cart summary forms. NEVER modify product add to cart, update, or change actions
    const isCartAddUpdateOrChange = actionAttr.includes('/cart/add') || actionAttr.includes('/cart/update') || actionAttr.includes('/cart/change');
    const isCheckoutOrCartPage = actionAttr.includes('/checkout') || actionAttr.includes('/cart');

    if (isCheckoutOrCartPage && !isCartAddUpdateOrChange) {
      const drawerCoupon = document.getElementById('CartCoupon');
      const pageCoupon = document.getElementById('CartPageCoupon');

      let discountVal = '';
      // Prefer active input values in the DOM, fallback to sessionStorage
      if (drawerCoupon) {
        discountVal = drawerCoupon.value.trim();
      } else if (pageCoupon) {
        discountVal = pageCoupon.value.trim();
      } else {
        discountVal = sessionStorage.getItem('cart_discount_code') || '';
      }

      if (discountVal) {
        sessionStorage.setItem('cart_discount_code', discountVal);
        try {
          const actionUrl = new URL(actionAttr, window.location.origin);
          actionUrl.searchParams.set('discount', discountVal);
          form.setAttribute('action', actionUrl.pathname + actionUrl.search);
        } catch (err) {
          console.error('Error modifying form action:', err);
        }
      } else {
        sessionStorage.removeItem('cart_discount_code');
        try {
          const actionUrl = new URL(actionAttr, window.location.origin);
          if (actionUrl.searchParams.has('discount')) {
            actionUrl.searchParams.delete('discount');
            form.setAttribute('action', actionUrl.pathname + actionUrl.search);
          }
        } catch (err) {
          console.error('Error modifying form action:', err);
        }
      }
    }
  }
});



// Expose functions to the global window scope so other scripts/components can use them
window.refreshCartDrawer = refreshCartDrawer;
window.updateCartBadges = updateCartBadges;
window.initCartAjaxHandlers = initCartAjaxHandlers;
window.initProductCards = initProductCards;
window.initCartCoupon = initCartCoupon;

/**
 * Initializes the main product page buy buttons (AJAX for Añadir al carrito)
 */
function initProductPageBuyButtons() {
  const form = document.querySelector('form[id^="product-form-"]') || document.getElementById('ProductForm');
  if (!form) return;

  const addToCartBtn = document.getElementById('ProductAddToCartBtn');
  const stickyForm = document.getElementById('sticky-product-form');
  const stickySubmitBtn = document.getElementById('StickySubmitBtn');

  // Helper function to submit product via AJAX and open the drawer
  // ¿El formulario del producto trae campos de personalizacion (foto, texto, consentimiento)?
  const formTienePropiedades = (f) => {
    try {
      return Array.from(new FormData(f).keys()).some(k => k.indexOf('properties[') === 0);
    } catch (e) {
      return false;
    }
  };

  const addProductViaAjax = (variantId, quantity, btn) => {
    if (!variantId) {
      console.error('No variant ID found for addition');
      return;
    }

    const isSticky = btn === stickySubmitBtn;
    const btnTextSpan = isSticky ? btn.querySelector('.sticky-btn-text') : btn.querySelector('.btn-text');
    if (!btnTextSpan) return;

    const originalContent = btnTextSpan.innerHTML;

    if (isSticky) {
      btnTextSpan.textContent = 'Añadiendo...';
    } else {
      btnTextSpan.textContent = 'Añadiendo...';
    }
    btn.disabled = true;

    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

    // Check if any addon checkboxes are checked
    const checkedAddons = document.querySelectorAll('.product-addon-checkbox:checked');
    let requestBody;
    let contentType;

    // La personalizacion manda sobre los add-ons: si el formulario trae properties[...],
    // el producto principal va por FormData (unica via que transporta la foto) y los add-ons
    // se anaden despues en una segunda llamada. Antes esta rama se evaluaba primero y armaba
    // un JSON con solo id y quantity: la foto, el texto y el consentimiento se perdian.
    const hayPersonalizacion = form && formTienePropiedades(form);

    if (checkedAddons.length > 0 && !hayPersonalizacion) {
      let items = [
        {
          id: parseInt(variantId),
          quantity: parseInt(quantity)
        }
      ];
      checkedAddons.forEach(checkbox => {
        const card = checkbox.closest('.product-addon-card');
        if (card) {
          const variantInput = card.querySelector('input[type="hidden"]');
          if (variantInput && variantInput.value) {
            items.push({
              id: parseInt(variantInput.value),
              quantity: 1
            });
          }
        }
      });
      requestBody = JSON.stringify({ items: items });
      contentType = 'application/json';
    } else if (form && formTienePropiedades(form)) {
      // Personalizacion: el pedido tiene que llevar properties[...] y, si hay foto, el
      // archivo. Solo FormData transporta las dos cosas. Antes se armaba el cuerpo a mano
      // con id y quantity, y todo lo que la clienta escribia se descartaba en silencio.
      requestBody = new FormData(form);
      requestBody.set('id', variantId);
      requestBody.set('quantity', quantity);
      // Un input de archivo vacio viaja igual y deja una propiedad «Foto» en blanco en el
      // pedido, o hace que Shopify responda 422. Se quitan antes de enviar.
      form.querySelectorAll('input[type="file"]').forEach(inp => {
        if (inp.name && (!inp.files || inp.files.length === 0)) requestBody.delete(inp.name);
      });
      // Sin Content-Type: el navegador pone el multipart con su boundary.
      contentType = null;
    } else {
      requestBody = new URLSearchParams({
        'id': variantId,
        'quantity': quantity
      }).toString();
      contentType = 'application/x-www-form-urlencoded';
    }

    fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: contentType
        ? { 'Content-Type': contentType, 'X-Requested-With': 'XMLHttpRequest' }
        : { 'X-Requested-With': 'XMLHttpRequest' },
      body: requestBody
    })
      .then(res => {
        if (!res.ok) throw new Error('AJAX Product Page Add fail');
        return res.json();
      })
      .then(item => {
        // Los add-ons marcados van en una segunda llamada: la primera tenia que ser
        // multipart para llevar la foto, y ahi no caben varias lineas.
        // Se releen los add-ons AQUI, no los de la NodeList de antes de subir la foto: la
        // subida tarda y la clienta puede haber marcado o desmarcado alguno mientras tanto.
        const addonsAhora = document.querySelectorAll('.product-addon-checkbox:checked');
        if (hayPersonalizacion && addonsAhora.length > 0) {
          const extras = [];
          addonsAhora.forEach(chk => {
            const tarjeta = chk.closest('.product-addon-card');
            const oculto = tarjeta && tarjeta.querySelector('input[type="hidden"]');
            if (oculto && oculto.value) extras.push({ id: parseInt(oculto.value), quantity: 1 });
          });
          if (extras.length) {
            fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: extras })
            })
              .then(r => {
                // Un add-on que no llega es dinero que la clienta cree haber pedido.
                if (!r.ok) throw new Error('add-on no añadido');
                if (window.refreshCartDrawer) window.refreshCartDrawer(false);
              })
              .catch(() => {
                if (btnTextSpan) btnTextSpan.textContent = 'Revisa los extras';
              });
          }
        }
        btnTextSpan.textContent = '¡Añadido!';

        // Refresh and open global theme cart drawer, or refresh cart page if we're on the main cart page!
        if (window.refreshCartPageContent) {
          window.refreshCartPageContent();
        } else if (window.refreshCartDrawer) {
          window.refreshCartDrawer(true);
        }

        setTimeout(() => {
          if (isSticky) {
            // Re-trigger the variant sync update to restore original price/label
            const priceDisplay = document.getElementById('StickyProductPrice');
            const formattedPrice = priceDisplay ? priceDisplay.textContent : '';
            btnTextSpan.innerHTML = `Añadir al carrito - <span class="sticky-btn-price">${formattedPrice}</span>`;
          } else {
            btnTextSpan.textContent = 'Añadir al carrito';
          }
          btn.disabled = false;
        }, 1500);
      })
      .catch(err => {
        console.error(err);
        if (window.showToast) {
          window.showToast('Error al añadir al carrito. Por favor, inténtelo de nuevo.');
        } else {
          alert('Error al añadir al carrito. Por favor, inténtelo de nuevo.');
        }

        if (isSticky) {
          const priceDisplay = document.getElementById('StickyProductPrice');
          const formattedPrice = priceDisplay ? priceDisplay.textContent : '';
          btnTextSpan.innerHTML = `Añadir al carrito - <span class="sticky-btn-price">${formattedPrice}</span>`;
        } else {
          btnTextSpan.textContent = 'Añadir al carrito';
        }
        btn.disabled = false;
      });
  };

  // Helper to detect if any bundle app (like Fast Bundle) is active on the page
  const isBundleActive = () => {
    return window.FastBundle ||
      window.fastBundle ||
      window.rbrBundle ||
      window.rbrBundleBuilder ||
      window.RBR ||
      document.querySelector('.rbrBundleBuilder, [class*="fast-bundle"], [class*="fast_bundle"], [class*="rbr"], [class*="bundle-builder"], .fast_bundle_container');
  };

  // Helper to detect if the request payload or form content contains bundle parameters
  const isBundleRequest = (body) => {
    if (!body) return false;
    let bodyStr = "";
    if (body instanceof FormData) {
      for (let [key, val] of body.entries()) {
        bodyStr += key + "=" + val + "&";
      }
    } else if (body instanceof URLSearchParams) {
      bodyStr = body.toString();
    } else if (typeof body === 'string') {
      bodyStr = body;
    } else {
      try {
        bodyStr = JSON.stringify(body);
      } catch (e) {
        bodyStr = "";
      }
    }
    return bodyStr.includes('__bundle') ||
      bodyStr.includes('bundle_id') ||
      bodyStr.includes('fast-bundle-') ||
      bodyStr.includes('properties[_');
  };

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', (e) => {
      // If Fast Bundle is active on the page AND the product form contains bundle parameters, bypass custom AJAX submission
      if (isBundleActive() && isBundleRequest(form ? new FormData(form) : null)) {
        return;
      }
      e.preventDefault();
      // El preventDefault cancela la validacion nativa del navegador, asi que hay que
      // dispararla a mano. Sin esto, la casilla de autorizacion de uso de imagen (Ley 1581)
      // se puede dejar sin marcar y el producto entra igual al carrito.
      if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) {
        return;
      }
      const variantIdInput = document.getElementById('SelectedVariantId');
      const qtyInput = document.getElementById('ProductQtyInput');

      const variantId = variantIdInput ? variantIdInput.value : '';
      const quantity = qtyInput ? qtyInput.value : '1';

      addProductViaAjax(variantId, quantity, addToCartBtn);
    });
  }

  if (stickySubmitBtn && stickyForm) {
    stickyForm.addEventListener('submit', (e) => {
      if (isBundleActive() && isBundleRequest(new FormData(stickyForm))) {
        return;
      }
      e.preventDefault();
    });
    stickySubmitBtn.addEventListener('click', (e) => {
      // If Fast Bundle is active on the page AND the sticky form contains bundle parameters, bypass custom AJAX submission
      if (isBundleActive() && isBundleRequest(new FormData(stickyForm))) {
        return;
      }
      e.preventDefault();

      // La barra fija usa `sticky-product-form`, que NO lleva los campos de personalizacion:
      // esos viven en el formulario principal de la ficha. Si el producto es personalizable,
      // esta ruta metia al carrito un pedido sin foto y sin la autorizacion de la Ley 1581.
      // En ese caso se delega en el boton principal, que ya valida y envia el FormData bueno.
      if (form && formTienePropiedades(form)) {
        const bloquePerso = document.querySelector('.perso');
        if (bloquePerso && typeof form.reportValidity === 'function' && !form.reportValidity()) {
          bloquePerso.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (addToCartBtn) { addToCartBtn.click(); return; }
      }

      const variantIdInput = document.getElementById('StickyVariantId');
      const qtyInput = document.getElementById('StickyQtyHidden');

      const variantId = variantIdInput ? variantIdInput.value : '';
      const quantity = qtyInput ? qtyInput.value : '1';

      addProductViaAjax(variantId, quantity, stickySubmitBtn);
    });
  }

}

/**
 * Global Wishlist Manager with LocalStorage Persistence
 */
const themeWishlist = {
  get() {
    try {
      return JSON.parse(localStorage.getItem('theme_wishlist')) || [];
    } catch (e) {
      return [];
    }
  },

  save(list) {
    localStorage.setItem('theme_wishlist', JSON.stringify(list));
    this.updateUI();
  },

  has(handle) {
    if (!handle) return false;
    const list = this.get();
    return list.some(item => item.handle === handle);
  },

  toggle(productData) {
    if (!productData || !productData.handle) return false;
    let list = this.get();
    const index = list.findIndex(item => item.handle === productData.handle);
    let added = false;

    if (index === -1) {
      list.push(productData);
      added = true;
      showToast('¡Agregado a la lista de deseos!');
    } else {
      list.splice(index, 1);
      showToast('¡Eliminado de la lista de deseos!');
    }

    this.save(list);
    return added;
  },

  remove(handle) {
    if (!handle) return;
    let list = this.get();
    list = list.filter(item => item.handle !== handle);
    this.save(list);
  },

  updateUI() {
    const list = this.get();
    const count = list.length;

    // Update count badges
    const badgeDesktop = document.getElementById('WishlistCount');
    const badgeMobile = document.getElementById('MobileWishlistCount');
    const badgeHamburger = document.getElementById('HamburgerWishlistCount');

    if (badgeDesktop) {
      badgeDesktop.textContent = count;
      badgeDesktop.style.display = count > 0 ? 'flex' : 'none';
    }
    if (badgeMobile) {
      badgeMobile.textContent = count;
      badgeMobile.style.display = count > 0 ? 'flex' : 'none';
    }
    if (badgeHamburger) {
      badgeHamburger.textContent = count;
      badgeHamburger.style.display = count > 0 ? 'inline-flex' : 'none';
    }

    // Update card buttons
    document.querySelectorAll('.product-card-item').forEach(card => {
      const handle = card.dataset.productHandle;
      if (!handle) return;

      const btn = card.querySelector('.wishlist-btn');
      if (!btn) return;

      const icon = btn.querySelector('svg');
      const isActive = this.has(handle);

      if (isActive) {
        btn.classList.add('is-active');
        btn.style.backgroundColor = '#e03a3a';
        btn.style.color = '#ffffff';
        if (icon) icon.setAttribute('fill', 'currentColor');
      } else {
        btn.classList.remove('is-active');
        btn.style.backgroundColor = '';
        btn.style.color = '';
        if (icon) icon.setAttribute('fill', 'none');
      }
    });

    // Update main product details page buttons
    const mainButtons = document.querySelectorAll('.product-wishlist-btn, #MainProductWishlistBtn');
    mainButtons.forEach(mainBtn => {
      const handle = mainBtn.dataset.productHandle;
      const isActive = this.has(handle);
      const icon = mainBtn.querySelector('svg');

      if (isActive) {
        mainBtn.classList.add('is-active');
        if (icon) icon.setAttribute('fill', 'currentColor');
      } else {
        mainBtn.classList.remove('is-active');
        if (icon) icon.setAttribute('fill', 'none');
      }
    });

    // Render wishlist drawer list
    const drawerWrapper = document.querySelector('.wishlist-drawer-wrapper');
    const drawerList = document.getElementById('WishlistDrawerItems');
    if (drawerWrapper && drawerList) {
      if (count === 0) {
        drawerWrapper.classList.add('is-wishlist-empty');
        drawerList.innerHTML = '';
      } else {
        drawerWrapper.classList.remove('is-wishlist-empty');
        drawerList.innerHTML = list.map(item => `
          <div class="wishlist-drawer-item" data-product-handle="${item.handle}">
            <div class="wishlist-item-image-box">
              <a href="${item.url || '#'}">
                <img src="${item.image || '//cdn.shopify.com/s/images/themes/product-1.png'}" alt="${item.title}" class="wishlist-item-img" loading="lazy">
              </a>
            </div>
            <div class="wishlist-item-details-box">
              <h3 class="wishlist-item-name">
                <a href="${item.url || '#'}">${item.title}</a>
              </h3>
              <div class="wishlist-item-price-val">
                ${item.price}
                ${item.compare_price ? `<span class="wishlist-item-compare-val">${item.compare_price}</span>` : ''}
              </div>
              <div class="wishlist-item-actions">
                <!--
                  `!== false` y no `=== true`: los favoritos guardados ANTES de este arreglo
                  no llevan el campo, y ante la duda se manda a la ficha. Doce de los trece
                  productos activos son personalizables, asi que equivocarse hacia el otro
                  lado seria lo raro, y el coste de acertar mal aqui es solo un clic de mas.
                -->
                <button type="button" class="wishlist-item-add-to-cart" data-variant-id="${item.variant_id || ''}" data-product-handle="${item.handle}"${item.personalizado !== false ? ` data-personalizado="true" data-handle-perso="${item.handle}"` : ''}>
                  Añadir al carrito
                </button>
                <button type="button" class="wishlist-item-remove" data-product-handle="${item.handle}">
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        `).join('');

        // Rebind events for newly created drawer elements
        this.bindDrawerActions();
      }
    }
  },

  bindDrawerActions() {
    const drawerList = document.getElementById('WishlistDrawerItems');
    if (!drawerList) return;

    // 1. Remove item button
    drawerList.querySelectorAll('.wishlist-item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = btn.dataset.productHandle;
        this.remove(handle);
      });
    });

    // 2. Add to cart button
    drawerList.querySelectorAll('.wishlist-item-add-to-cart').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        // El cajon de favoritos se renderiza en TODAS las paginas y mandaba
        // {items:[{id,quantity}]} sin propiedades: quien guardara la camiseta personalizada
        // y la anadiera desde aqui obtenia una linea de pedido sin foto y sin autorizacion,
        // sin haber pisado la ficha.
        if (window.atelierGatePersonalizado(btn)) return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        // Show loading spinner/text
        const originalText = btn.textContent;
        btn.textContent = 'Agregando...';
        btn.disabled = true;

        // Add to Cart via dynamic AJAX API request
        const formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js') + '?skip_sync=1', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Error adding to cart');
            }
            return response.json();
          })
          .then(data => {
            btn.textContent = '¡Agregado!';
            showToast('¡Producto añadido al carrito!');

            // Refresh the global Cart Drawer if available
            if (window.refreshCartDrawer) {
              window.refreshCartDrawer(true);
            } else {
              window.location.href = '/cart';
            }

            // Close wishlist drawer
            const wishlistDrawer = document.getElementById('WishlistDrawer');
            if (wishlistDrawer) {
              wishlistDrawer.classList.remove('is-open');
            }

            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            btn.textContent = 'Error';
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          });
      });
    });
  }
};
window.themeWishlist = themeWishlist;

/**
 * Initializes interactive behaviors for the Wishlist Drawer
 */
function initWishlistDrawer() {
  const wishlistDrawer = document.getElementById('WishlistDrawer');
  const wishlistClose = document.querySelector('.wishlist-drawer-close');
  const wishlistOverlay = document.querySelector('.wishlist-drawer-overlay');

  if (!wishlistDrawer) return;

  // Open Wishlist Drawer
  const triggers = document.querySelectorAll('#HeaderWishlistTrigger, #MobileWishlistTrigger, .hamburger-wishlist-trigger');
  triggers.forEach(trigger => {
    if (trigger.dataset.drawerInitialized) return;
    trigger.dataset.drawerInitialized = 'true';
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      // Close mobile navigation drawer if open
      const mobileNavDrawer = document.getElementById('MobileNavDrawer');
      const mobileDrawerOverlay = document.querySelector('.mobile-drawer-overlay');
      if (mobileNavDrawer) {
        mobileNavDrawer.classList.remove('is-open');
      }
      if (mobileDrawerOverlay) {
        mobileDrawerOverlay.classList.remove('is-active');
      }

      wishlistDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Lock background scrolling
    });
  });

  // Close Wishlist Drawer
  const closeDrawer = () => {
    wishlistDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (wishlistClose) wishlistClose.addEventListener('click', closeDrawer);
  if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeDrawer);
}

/**
 * Initializes interactive behaviors for the Main Product Details page Wishlist button
 */
function initMainProductWishlist() {
  const mainButtons = document.querySelectorAll('.product-wishlist-btn, #MainProductWishlistBtn');
  if (mainButtons.length === 0) return;

  mainButtons.forEach(mainBtn => {
    if (mainBtn.dataset.wishlistInitialized) return;
    mainBtn.dataset.wishlistInitialized = 'true';

    mainBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Find matching selected variant ID from form input if available
      const selectedVariantIdInput = document.getElementById('SelectedVariantId');
      const activeVariantId = selectedVariantIdInput ? selectedVariantIdInput.value : mainBtn.dataset.variantId;

      const productData = {
        handle: mainBtn.dataset.productHandle,
        title: mainBtn.dataset.productTitle,
        price: mainBtn.dataset.productPrice,
        compare_price: mainBtn.dataset.productComparePrice || null,
        image: mainBtn.dataset.productImage,
        url: mainBtn.dataset.productUrl,
        variant_id: activeVariantId,
        personalizado: mainBtn.getAttribute('data-personalizado') === 'true'
      };

      if (window.themeWishlist) {
        window.themeWishlist.toggle(productData);
      }
    });
  });
}

/* ==========================================================================
   GLOBAL CART AJAX INTERCEPTOR FOR THIRD-PARTY APPS
   ========================================================================== */
(function () {
  // Estado para controlar las peticiones concurrentes de bundles
  let bundleRequestsInFlight = 0;
  let bundleDebounceTimeout = null;
  let bundleHasErrors = false;

  // Helper para detectar si alguna app de bundle está activa en la página
  const isBundleAppActive = () => {
    return window.FastBundle ||
      window.fastBundle ||
      window.rbrBundle ||
      window.rbrBundleBuilder ||
      window.RBR ||
      document.querySelector('.rbrBundleBuilder, [class*="fast-bundle"], [class*="fast_bundle"], [class*="rbr"], [class*="bundle-builder"], .fast_bundle_container');
  };

  // Verifica si el payload corresponde a un bundle (acotado para evitar propiedades genéricas con _)
  const isBundleRequest = (body) => {
    if (!body) return false;
    let bodyStr = "";
    if (body instanceof FormData) {
      for (let [key, val] of body.entries()) {
        bodyStr += key + "=" + val + "&";
      }
    } else if (body instanceof URLSearchParams) {
      bodyStr = body.toString();
    } else if (typeof body === 'string') {
      bodyStr = body;
    } else {
      try {
        bodyStr = JSON.stringify(body);
      } catch (e) {
        bodyStr = "";
      }
    }
    return bodyStr.includes('__bundle') ||
      bodyStr.includes('bundle_id') ||
      bodyStr.includes('fast-bundle-') ||
      bodyStr.includes('properties[_bundle') ||
      bodyStr.includes('properties[_fast_bundle');
  };

  // Función al iniciar una petición de bundle: incrementa contador y muestra estado de carga
  const startBundleRequest = () => {
    bundleRequestsInFlight++;
    if (bundleRequestsInFlight === 1) {
      if (bundleDebounceTimeout) clearTimeout(bundleDebounceTimeout);
      
      // Aplicar estado visual de carga en el drawer
      const currentDrawer = document.getElementById('CartDrawer');
      const sectionElement = currentDrawer ? currentDrawer.closest('.shopify-section') : null;
      if (sectionElement) {
        sectionElement.classList.add('is-updating');
      }
      if (typeof showToast === 'function') {
        showToast('Agregando bundle al carrito...');
      }
    }
  };

  // Función al finalizar una petición de bundle: decrementa contador y ejecuta debounce al llegar a 0
  const completeBundleRequest = (success, errorMsg) => {
    bundleRequestsInFlight = Math.max(0, bundleRequestsInFlight - 1);
    
    if (!success) {
      bundleHasErrors = true;
      if (typeof showToast === 'function') {
        showToast(errorMsg || 'Error al añadir un producto del bundle.');
      }
    }

    if (bundleRequestsInFlight === 0) {
      if (bundleDebounceTimeout) clearTimeout(bundleDebounceTimeout);
      
      bundleDebounceTimeout = setTimeout(() => {
        // Remover estado visual de carga
        const currentDrawer = document.getElementById('CartDrawer');
        const sectionElement = currentDrawer ? currentDrawer.closest('.shopify-section') : null;
        if (sectionElement) {
          sectionElement.classList.remove('is-updating');
        }

        // Refrescar y abrir el Cart Drawer
        if (window.refreshCartDrawer) {
          window.refreshCartDrawer(true);
        }

        // Mostrar notificación de resultado final
        if (typeof showToast === 'function') {
          if (bundleHasErrors) {
            showToast('El bundle se agregó con algunos errores. Por favor revisa tu carrito.');
            bundleHasErrors = false; // Resetear bandera
          } else {
            showToast('¡Bundle agregado al carrito exitosamente!');
          }
        }
        bundleDebounceTimeout = null;
      }, 450); // Debounce de 450ms desde la última petición completada
    }
  };

  // Interceptar e impedir recargas o redirecciones físicas durante la adición AJAX de un bundle
  try {
    const originalReload = window.location.reload;
    window.location.reload = function () {
      if (bundleRequestsInFlight > 0 || bundleDebounceTimeout !== null) {
        console.warn("Se previno la recarga física de la página (location.reload) por adición de bundle activa.");
        return;
      }
      return originalReload.apply(window.location, arguments);
    };
  } catch (e) {
    console.warn("No se pudo sobrescribir window.location.reload", e);
  }

  try {
    const originalAssign = window.location.assign;
    window.location.assign = function (url) {
      if ((bundleRequestsInFlight > 0 || bundleDebounceTimeout !== null) && url.includes('/cart')) {
        console.warn("Se previno la redirección (location.assign) a /cart por adición de bundle activa.");
        return;
      }
      return originalAssign.apply(window.location, arguments);
    };
  } catch (e) {}

  try {
    const originalReplace = window.location.replace;
    window.location.replace = function (url) {
      if ((bundleRequestsInFlight > 0 || bundleDebounceTimeout !== null) && url.includes('/cart')) {
        console.warn("Se previno la redirección (location.replace) a /cart por adición de bundle activa.");
        return;
      }
      return originalReplace.apply(window.location, arguments);
    };
  } catch (e) {}

  const handleCartSync = (urlString) => {
    setTimeout(() => {
      if (window.location.pathname === '/cart' && window.refreshCartPageContent) {
        window.refreshCartPageContent();
      } else if (window.refreshCartDrawer) {
        const shouldOpen = urlString.includes('/cart/add');
        window.refreshCartDrawer(shouldOpen);
      }
    }, 250);
  };

  // 1. Interceptar Fetch API
  const originalFetch = window.fetch;
  window.fetch = function () {
    const [url, options] = arguments;
    const urlString = typeof url === 'string' ? url : (url instanceof URL ? url.href : (url && url.url ? url.url : ''));

    const isBundle = isBundleAppActive() && isBundleRequest(options && options.body) && 
                     (urlString.includes('/cart/add') || urlString.includes('/cart/change') || urlString.includes('/cart/update'));

    if (isBundle) {
      startBundleRequest();
      return originalFetch.apply(window, arguments)
        .then(response => {
          if (response.ok) {
            completeBundleRequest(true);
          } else {
            // Intentar extraer el mensaje de error de Shopify
            response.clone().json().then(data => {
              const errMsg = data.description || data.message || 'Error al añadir el producto del bundle';
              completeBundleRequest(false, errMsg);
            }).catch(() => {
              completeBundleRequest(false);
            });
          }
          return response;
        })
        .catch(err => {
          completeBundleRequest(false, err.message || 'Error de red al añadir el bundle');
          throw err;
        });
    }

    if (urlString.includes('skip_sync=1')) {
      return originalFetch.apply(window, arguments);
    }

    if (urlString.includes('/cart/add') || urlString.includes('/cart/change') || urlString.includes('/cart/update')) {
      return originalFetch.apply(window, arguments).then(response => {
        if (response.ok) {
          handleCartSync(urlString);
        }
        return response;
      });
    }
    return originalFetch.apply(window, arguments);
  };

  // 2. Interceptar XMLHttpRequest API
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = typeof url === 'string' ? url : (url instanceof URL ? url.href : '');
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const urlString = this._url || '';
    const isBundle = isBundleAppActive() && isBundleRequest(body) && 
                     (urlString.includes('/cart/add') || urlString.includes('/cart/change') || urlString.includes('/cart/update'));

    if (isBundle) {
      startBundleRequest();
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          completeBundleRequest(true);
        } else {
          let errMsg = 'Error al añadir el producto del bundle';
          try {
            const data = JSON.parse(this.responseText);
            errMsg = data.description || data.message || errMsg;
          } catch(e) {}
          completeBundleRequest(false, errMsg);
        }
      });
      this.addEventListener('error', function () {
        completeBundleRequest(false, 'Error de red al añadir el bundle');
      });
      return originalSend.apply(this, arguments);
    }

    this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) {
        if (urlString.includes('skip_sync=1')) {
          return;
        }
        if (urlString.includes('/cart/add') || urlString.includes('/cart/change') || urlString.includes('/cart/update')) {
          handleCartSync(urlString);
        }
      }
    });

    return originalSend.apply(this, arguments);
  };
})();

// Intersection Observer for scroll animations (.reveal-on-scroll, .reveal-container-on-scroll, .zoom-in-on-scroll)
function initScrollAnimations() {
  const animationsEnabled = document.body.getAttribute('data-scroll-animations') !== 'disabled';
  const containerEnabled = document.body.getAttribute('data-container-animations') !== 'disabled';
  const zoomEnabled = document.body.getAttribute('data-zoom-animations') !== 'disabled';

  if (!animationsEnabled) {
    // If text animations are disabled, immediately make all elements visible
    document.querySelectorAll(".reveal-on-scroll, .reveal-container-on-scroll, .zoom-in-on-scroll").forEach(el => {
      el.classList.add("is-visible");
    });
    return;
  }

  if (!containerEnabled) {
    // If container animations are disabled, immediately make container elements visible
    document.querySelectorAll(".reveal-container-on-scroll").forEach(el => {
      el.classList.add("is-visible");
    });
  }

  if (!zoomEnabled) {
    // If zoom animations are disabled, immediately show zoom-in elements
    document.querySelectorAll(".zoom-in-on-scroll").forEach(el => {
      el.classList.add("is-visible");
    });
  }

  const observerOptions = {
    root: null,
    rootMargin: "0px 0px -10% 0px",
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe text reveal elements
  document.querySelectorAll(".reveal-on-scroll").forEach(el => observer.observe(el));

  // Observe container reveal elements only if container animations are enabled
  if (containerEnabled) {
    document.querySelectorAll(".reveal-container-on-scroll").forEach(el => observer.observe(el));
  }

  // Observe zoom elements only if zoom is enabled
  if (zoomEnabled) {
    document.querySelectorAll(".zoom-in-on-scroll").forEach(el => observer.observe(el));
  }
}

document.addEventListener("DOMContentLoaded", initScrollAnimations);
document.addEventListener("shopify:section:load", initScrollAnimations);

/**
 * Pausa los marquees de las tarjetas de producto que están fuera del viewport.
 *
 * Una página de colección puede tener 30 de estos corriendo a la vez. Aunque
 * animan transform, mientras corren obligan al navegador a recalcular estilo en
 * cada frame, y ese trabajo se acumula justo cuando el usuario toca algo: es el
 * mayor componente del retardo de pintado que mide el INP.
 *
 * Se marca la clase en el sentido seguro: por defecto el marquee anima igual que
 * antes, y solo se pausa cuando confirmamos que no se ve. Si el navegador no
 * soporta IntersectionObserver, todo queda como estaba.
 */
function initMarqueePausing() {
  if (!('IntersectionObserver' in window)) return;

  const marquees = document.querySelectorAll('.product-card-marquee-content:not([data-marquee-observed])');
  if (!marquees.length) return;

  if (!window.__marqueeObserver) {
    window.__marqueeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
      });
    }, { rootMargin: '200px 0px' });
  }

  marquees.forEach(el => {
    el.dataset.marqueeObserved = 'true';
    el.classList.add('is-offscreen');
    window.__marqueeObserver.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', initMarqueePausing);
document.addEventListener('shopify:section:load', initMarqueePausing);

/**
 * Intercept search form submissions to add wildcards (*) for broad/partial matching
 * and save successfully searched queries to localStorage history
 */
document.addEventListener('submit', function (e) {
  const searchForm = e.target.closest('form[action*="/search"]');
  if (searchForm) {
    const qInput = searchForm.querySelector('input[name="q"]');
    if (qInput && qInput.value.trim()) {
      const originalValue = qInput.value.trim();

      // Guardar en el historial de localStorage
      try {
        let history = JSON.parse(localStorage.getItem('theme_search_history') || '[]');
        // Eliminar si ya existe para evitar duplicados
        history = history.filter(item => item.toLowerCase() !== originalValue.toLowerCase());
        // Añadir al inicio
        history.unshift(originalValue);
        // Limitar a 5 búsquedas más recientes
        history = history.slice(0, 5);
        localStorage.setItem('theme_search_history', JSON.stringify(history));
      } catch (err) {
        console.error('Error saving search history:', err);
      }

      if (window.theme && window.theme.enableBroadSearch) {
        // Check if it already has wildcards to avoid double-appending
        if (!originalValue.includes('*')) {
          // Format query: append * to each word (word length > 1)
          const formattedValue = originalValue
            .split(/\s+/)
            .map(word => {
              if (word.length > 1 && !word.endsWith('*')) {
                return word + '*';
              }
              return word;
            })
            .join(' ');

          // Create a hidden input to submit the formatted value instead of altering visible input
          let hiddenInput = searchForm.querySelector('input[name="q"][type="hidden"]');
          if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'q';
            searchForm.appendChild(hiddenInput);
          }
          hiddenInput.value = formattedValue;
          qInput.disabled = true; // disable the original input so its value isn't sent

          // Re-enable after submit so if user navigates back, they can edit it
          setTimeout(() => {
            qInput.disabled = false;
          }, 100);
        }
      }
    }
  }
});


